import React, { useState, useEffect, useRef } from "react";
import back_arrow from "../assets/svg/back-arrow.svg";
import plus_icon from "../assets/svg/plus_icon.svg";
import split from "../assets/svg/split.svg";
import sales from "../assets/svg/sales.svg";
import cost from "../assets/svg/cost.svg";
import split_hover from "../assets/svg/split-b.svg";
import sales_hover from "../assets/svg/sales-b.svg";
import cost_hover from "../assets/svg/cost-b.svg";
import schedule_icon from "../assets/svg/schedule_icon.svg";
import "../styles/contracts_popup.css";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import Contracts_header from './Header/Contracts_header';
import small_line from "../assets/svg/small_line.svg";
import delete_icon from "../assets/svg/delete_icon.svg";
import repeat_stroke_rounded from "../assets/svg/repeat_stroke_rounded.svg";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import AsyncSelect from 'react-select/async';
import axiosInstance from "../axiosInstance";
import DraggableDivider from "../Component/Jobs/DraggableDivider";
import CommonFooter from "../CommonFooter/CommonFooter";
import { SquarePen } from "lucide-react";
import CommonRemarkPopup from "../CommonRemarkPopup/CommonRemarkPopup";

const ContractsPopup = ({ id }) => {

  const [isPopupOpen, setIsPopupOpen] = useState(true);
  const [isJobDropdownOpen, setIsJobDropdownOpen] = useState(false);
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [periodJobs, setPeriodJobs] = useState([]);
  const dropdownRef = useRef(null);
  const [allCategories, setAllCategories] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [jobOptions, setJobOptions] = useState([]);
  const [projectId, setselectedprojectId] = useState(0);
  const [selectedChargeIds, setSelectedChargeIds] = useState({});
  const [contractId, setContractId] = useState(0);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [hasProjectChanged, setHasProjectChanged] = useState(false);
  const [vendorSuggestions, setVendorSuggestions] = useState([]);
  const [showVendorSuggestions, setShowVendorSuggestions] = useState({});
  const [vendorInputValues, setVendorInputValues] = useState({});
  const [selectedVendorIds, setSelectedVendorIds] = useState({});
  const [salesInputValues, setSalesInputValues] = useState({});
  const [costInputValues, setCostInputValues] = useState({});
  const [selectedSalesChargeIds, setSelectedSalesChargeIds] = useState({});
  const [selectedCostChargeIds, setSelectedCostChargeIds] = useState({});
  const [salesSuggestionsMap, setSalesSuggestionsMap] = useState({});
  const [costSuggestionsMap, setCostSuggestionsMap] = useState({});
  const [showSalesSuggestionsMap, setShowSalesSuggestionsMap] = useState({});
  const [showCostSuggestionsMap, setShowCostSuggestionsMap] = useState({});
  const [showRemarkPopup, setShowRemarkPopup] = useState(false);
  const [remarkValue, setRemarkValue] = useState("");
  const [remarkMeta, setRemarkMeta] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [deletedJobTypeIds, setDeletedJobTypeIds] = useState([]);
  const [deletedSalesLineIds, setDeletedSalesLineIds] = useState([]);
  const [deletedCostLineIds, setDeletedCostLineIds] = useState([]);

  const [mailInput, setMailInput] = useState("");
  const [mailTags, setMailTags] = useState([]);
  const [emailError, setEmailError] = useState("");

  const isValidEmail = (email) => {
    if (!email) return false;
    if (email.includes("..")) return false;
    if (email.startsWith(".") || email.endsWith(".")) return false;
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };

  const validateMailBeforeSubmit = () => {

    const pendingVal = mailInput.trim();
    if (pendingVal) {
      if (!isValidEmail(pendingVal)) {
        setEmailError("Invalid email format");
        toast.error("Please fix the invalid email before submitting.");
        return false;
      }
      if (!mailTags.includes(pendingVal)) {
        const updated = [...mailTags, pendingVal];
        setMailTags(updated);
        setFormData(prev => ({ ...prev, contract_mail: updated.join(",") }));
      }
      setMailInput("");
      setEmailError("");
    }

    if (mailTags.length > 0) {
      const invalidMails = mailTags.filter(email => !isValidEmail(email));
      if (invalidMails.length > 0) {
        toast.error(`Invalid email format: ${invalidMails.join(", ")}`);
        return false;
      }
    }

    return true;
  };

  const tableRefs = useRef({});

  const getTableRef = (categoryId, type) => {
    if (!tableRefs.current[categoryId]) {
      tableRefs.current[categoryId] = {
        sales: React.createRef(),
        cost: React.createRef()
      };
    }
    return tableRefs.current[categoryId][type];
  };
  const [viewModes, setViewModes] = useState({});

  // contract period states
  const [showPopup, setShowPopup] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState("weekly");
  const [activeDay, setActiveDay] = useState("Mon");
  const [weeklyInterval, setWeeklyInterval] = useState(1);
  const [monthlyDay, setMonthlyDay] = useState(18);
  const [monthlyOption, setMonthlyOption] = useState("day"); // "day" or "weekday"
  const [monthlyWeek, setMonthlyWeek] = useState("first");
  const [monthlyWeekday, setMonthlyWeekday] = useState("monday");
  const [monthlyInterval, setMonthlyInterval] = useState(1);


  const weekDays = [
    { label: "S", value: "Sun" },
    { label: "M", value: "Mon" },
    { label: "T", value: "Tue" },
    { label: "W", value: "Wed" },
    { label: "T", value: "Thu" },
    { label: "F", value: "Fri" },
    { label: "S", value: "Sat" },
  ];



  // new
  const [jobTypeSchedules, setJobTypeSchedules] = useState({});
  const [jobTypeBeingScheduled, setJobTypeBeingScheduled] = useState(null); // category.id

  const [triggerStartDate, setTriggerStartDate] = useState('');
  const [triggerEndDate, setTriggerEndDate] = useState('');
  const [nextTriggerDateDisplay, setNextTriggerDateDisplay] = useState('');

  // Recalculate next trigger date whenever schedule settings change
  useEffect(() => {
    let startDate = new Date(triggerStartDate);
    let endDate = new Date(triggerEndDate);
    const today = new Date();
    
    // Normalize dates (remove time portion for comparison)
    today.setHours(0, 0, 0, 0);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    if (isNaN(startDate.getTime())) startDate = new Date(today);
    if (isNaN(endDate.getTime())) endDate = new Date("9999-12-31");

    // Return empty if range already expired
    if (today > endDate) {
      setNextTriggerDateDisplay("");
      return;
    }

    // Determine calculation start date
    const calcStartDate = today < startDate ? new Date(startDate) : new Date(today);

    let result = "";

    if (selectedPeriod === "weekly") {
      const targetDay = weekDays.findIndex(d => d.value === activeDay);
      let nextDate = new Date(calcStartDate);
      const currentDay = nextDate.getDay();
      const diffToTarget = (targetDay - currentDay + 7) % 7;

      nextDate.setDate(nextDate.getDate() + diffToTarget);

      // If it's today and we already passed it, or if we got 0 days diff, add interval
      if (nextDate <= calcStartDate || (diffToTarget === 0 && calcStartDate.getDay() === targetDay && calcStartDate > today)) {
        // Already on target day, move forward by interval
        nextDate.setDate(nextDate.getDate() + weeklyInterval * 7);
      }

      result = nextDate <= endDate ? nextDate.toDateString() : "";
    }

    if (selectedPeriod === "monthly") {
      const targetDay = Math.min(parseInt(monthlyDay) || 1, 31);
      const interval = parseInt(monthlyInterval) || 1;

      let nextDate = new Date(calcStartDate);
      nextDate.setDate(targetDay);

      // If the target day in current/start month hasn't occurred yet, use it
      // Otherwise, add interval and set to target day
      if (nextDate < calcStartDate) {
        nextDate.setMonth(nextDate.getMonth() + interval);
        nextDate.setDate(targetDay);
      }

      // Fix month overflow (e.g., Feb 30 -> Feb 28/29)
      while (nextDate.getDate() !== targetDay && nextDate.getDate() > 0) {
        nextDate.setDate(nextDate.getDate() - 1);
      }

      result = nextDate <= endDate ? nextDate.toDateString() : "";
    }

    setNextTriggerDateDisplay(result);
  }, [selectedPeriod, activeDay, weeklyInterval, monthlyDay, monthlyInterval, triggerStartDate, triggerEndDate, weekDays]);



  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  const getOrdinalSuffix = (day) => {
    const lastDigit = day % 10;
    const lastTwoDigits = day % 100;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return 'th';
    if (lastDigit === 1) return 'st';
    if (lastDigit === 2) return 'nd';
    if (lastDigit === 3) return 'rd';
    return 'th';
  };

  const getReadableSchedule = (schedule) => {
    if (!schedule) return "";

    if (schedule.periodType === 'weekly') {
      return `Every ${Number(schedule.weeklyInterval) || 1} week(s) on ${capitalize(schedule.weeklyDay || 'Mon')}`;
    } else {
      const interval = Number(schedule.monthlyInterval) || 1;
      const day = Number(schedule.monthlyDay) || 1;
      
      if (interval === 1) {
        return `Monthly on ${day}${getOrdinalSuffix(day)}`;
      } else {
        return `Once every ${interval} months on ${day}${getOrdinalSuffix(day)}`;
      }
    }
  };

  const checkboxRef = useRef();
  const allCategoryIds = allCategories.map(cat => cat.id);


  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate =
        periodJobs.length > 0 && periodJobs.length < allCategoryIds.length;
    }
  }, [periodJobs, allCategoryIds]);

  // Update selectedDateRange when jobTypeSchedules changes
  useEffect(() => {
    if (!jobTypeBeingScheduled && periodJobs.length > 0) {
      const allSchedules = periodJobs.map(jobId => jobTypeSchedules[jobId]).filter(s => s);
      
      if (allSchedules.length === periodJobs.length && allSchedules.length > 0) {
        const firstSchedule = allSchedules[0];
        const allSame = allSchedules.every(s => 
          s.periodType === firstSchedule.periodType &&
          s.weeklyInterval === firstSchedule.weeklyInterval &&
          s.weeklyDay === firstSchedule.weeklyDay &&
          s.monthlyInterval === firstSchedule.monthlyInterval &&
          s.monthlyDay === firstSchedule.monthlyDay
        );
        
        if (allSame) {
          setSelectedDateRange(getReadableSchedule(firstSchedule));
        } else {
          setSelectedDateRange('');
        }
      } else {
        setSelectedDateRange('');
      }
    }
  }, [jobTypeSchedules, periodJobs, jobTypeBeingScheduled]);


  const navigate = useNavigate();
  const locationData = useLocation();
  const contract_data = locationData.state?.charges || {};


  useEffect(() => {
    if (contract_data && Object.keys(contract_data).length > 0) {
      setIsEdit(true);
    } else {
      setIsEdit(false);
    }
  }, [contract_data]);
  console.log("contract_data", contract_data);


  // Edit
  const [formData, setFormData] = useState({
    project_id: "",
    job_type_id: "",
    contract_start_date: "",
    contract_expiry_date: "",
    contract_code: "",
    contract_mail: "",
    job_creation_period: "",
    supply_period_start_day: "",
    supply_period_end_day: ""
  });



  const handleEditLoad = async (projectIdFromApi) => {
    try {
      // const response = await axios.get(
      //   "https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/costsolution/projects/autosuggestion",
      //   { params: { query: "" } }
      // );

      const response = await axiosInstance.get(
        "/costsolution/projects/autosuggestion",
        { params: { query: "" } }
      );

      if (response.data?.autosuggestion) {
        const options = response.data.autosuggestion.map(item => ({
          label: item.label,
          value: item.value
        }));
        setProjectOptions(options);

        const selected = options.find((item) => item.value === projectIdFromApi);

        if (selected) {
          setProjectInput(selected.label);
          setselectedproject(selected.value);
          setselectedprojectId(selected.value);
          setSelectedProject(selected); // This is crucial for AsyncSelect
        }
      }
    } catch (error) {
      console.error("Failed to load project suggestions:", error);
    }
  };




  useEffect(() => {
    const loadEditData = async () => {
      try {
        if (contract_data) {
          setIsEdit(true);
          setContractId(contract_data.id);

          setFormData({
            project_id: contract_data.project_id || "",
            contract_start_date: contract_data.contract_start_date?.split(" ")[0] || '',
            contract_expiry_date: contract_data.contract_expiry_date?.split(" ")[0] || '',
            contract_code: contract_data.contract_code || '',
            contract_mail: contract_data.contract_mail || '',
            supply_period_start_day: contract_data.supply_period_start_day || "",
            supply_period_end_day: contract_data.supply_period_end_day || ""
          });

          if (contract_data.contract_mail) {
            const tags = contract_data.contract_mail.split(",").map(e => e.trim()).filter(Boolean);
            setMailTags(tags);
          }

          await handleEditLoad(contract_data.project_id);
          // const projectResponse = await axios.get(
          //   "https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/costsolution/projects/autosuggestion",
          //   { params: { query: "" } }
          // );

          const projectResponse = await axiosInstance.get(
            "/costsolution/projects/autosuggestion",
            { params: { query: "" } }
          );

          if (projectResponse.data?.autosuggestion) {
            const options = projectResponse.data.autosuggestion;
            setProjectOptions(options);

            const selected = options.find(item => item.value === contract_data.project_id);
            if (selected) {
              setProjectInput(selected.label);
              setselectedproject(selected.value);
              setselectedprojectId(selected.value);
            }
          }

          if (contract_data.project_id) {
            const jobResponse = await axiosInstance.get(
              `/project_based/getJobTypes/${contract_data.project_id}`
            );

            if (jobResponse.data && Array.isArray(jobResponse.data.jobtypes)) {
              setJobOptions(jobResponse.data.jobtypes);
            }
          }

          if (contract_data.job_type && !hasProjectChanged) {
            let mappedCategories = contract_data.job_type.map(job => ({
              id: job.job_type_id,
              job_type_name: job.job_type_name || "",
              contract_job_table_id: job.contract_job_table_id,
              salesRows: job.chargelines?.sales?.map((line, index) => ({
                charge_id: line.charge_id,
                description: line.description_of_charges || "",
                po_wo_number: line.po_wo_number || "",
                po_wo_date: line.po_wo_date?.split(" ")[0] || "",
                contract_charge_line_table_id: line.contract_charge_line_table_id,
                SalesunitQuantity: parseFloat(line.unit_of_quantity) || 0,
                salesRemarks: line.remarks || "",
                salesRate: parseFloat(line.unit_of_rate) || 0,
                salesNetTotal: parseFloat(line.net_total) || 0,
                chargecode: line.charge_name || "",
              })),
              costRows: job.chargelines?.cost?.map((line, index) => ({
                charge_id: line.charge_id,
                description: line.description_of_charges || "",
                po_wo_number: line.po_wo_number || "",
                po_wo_date: line.po_wo_date?.split(" ")[0] || "",
                vendor_name: line.vendor_name || "",
                vendor_id: line.vendor_id || 0,
                costRemarks: line.remarks || "",
                CostunitQuantity: parseFloat(line.unit_of_quantity) || 0,
                costRate: parseFloat(line.unit_of_rate) || 0,
                costNetTotal: parseFloat(line.net_total) || 0,
                chargecode: line.charge_name || "",
                contract_charge_line_table_id: line.contract_charge_line_table_id,
              }))
            }));

            // ⬇️ Hydrate jobTypeSchedules from `job_type_period`
            const scheduleMap = {};
            contract_data.job_type.forEach(job => {
              const period = job.job_type_period;
              console.log("perioddddddddddddddddd", period);
              if (!period) return;

              if (period.period_type === "weekly") {
                scheduleMap[job.job_type_id] = {
                  periodType: "weekly",
                  weeklyInterval: Number(period.week_once) || 1,
                  weeklyDay: (period.week_days || "Mon"),
                };
              } else if (period.period_type === "monthly") {
                scheduleMap[job.job_type_id] = {
                  periodType: "monthly",
                  monthlyDay: Number(period.month_date) || 1,
                  monthlyInterval: (period.month_period),
                };
              }
            });
            setJobTypeSchedules(scheduleMap);

            // const chargeCodeResponse = await axios.get(
            //   `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/project_based/getchargecodes/${contract_data.project_id}`
            // );

            const salesChargeCodeResponse = await axiosInstance.get(
              `/getnonprojectsaleschargecodes`
            );

            const costChargeCodeResponse = await axiosInstance.get(
              `/getnonprojectcostchargecodes`
            );

            if (salesChargeCodeResponse.data?.chargecodes && costChargeCodeResponse.data?.chargecodes) {
              console.log("inside charge code");
              console.log("Sales Charge Code List:", salesChargeCodeResponse.data.chargecodes);
              console.log("Cost Charge Code List:", costChargeCodeResponse.data.chargecodes);

              const salesChargeList = salesChargeCodeResponse.data.chargecodes;
              const costChargeList = costChargeCodeResponse.data.chargecodes;

              mappedCategories = mappedCategories.map(category => {
                const updatedSalesRows = category.salesRows.map(row => {
                  const matched = salesChargeList.find(code => Number(code.value) === Number(row.charge_id));
                  return {
                    ...row,
                    chargecode: matched ? matched.label : row.chargecode
                  };
                });

                const updatedCostRows = category.costRows.map(row => {
                  const matched = costChargeList.find(code => Number(code.value) === Number(row.charge_id));
                  return {
                    ...row,
                    chargecode: matched ? matched.label : row.chargecode
                  };
                });

                return {
                  ...category,
                  salesRows: updatedSalesRows,
                  costRows: updatedCostRows
                };
              });

              // Calculate totals
              mappedCategories = mappedCategories.map(category => {
                const totalSales = category.salesRows.reduce((acc, row) => {
                  return acc + (parseFloat(row.salesNetTotal) || 0);
                }, 0);

                const totalCost = category.costRows.reduce((acc, row) => {
                  return acc + (parseFloat(row.costNetTotal) || 0);
                }, 0);

                const profitAmount = totalSales - totalCost;

                const profitPercent = totalCost > 0
                  ? ((profitAmount / totalCost) * 100).toFixed(2)
                  : '0.00';

                return {
                  ...category,
                  salesNetTotal: totalSales.toFixed(2),
                  costNetTotal: totalCost.toFixed(2),
                  profitAmount: profitAmount.toFixed(2),
                  profitPercent
                };
              });
            }

            setAllCategories(mappedCategories);
            const jobIds = contract_data.job_type.map(job => job.job_type_id);
            setSelectedJobs(jobIds);
            setPeriodJobs(jobIds);
            console.log("selectedJobs updated: ", jobIds);

            // In the loadEditData function, replace the initial values setup:
            const initialSalesInputValues = {};
            const initialCostInputValues = {};
            const initialSelectedSalesChargeIds = {};
            const initialSelectedCostChargeIds = {};

            mappedCategories.forEach((category, catIndex) => {
              initialSalesInputValues[catIndex] = {};
              initialCostInputValues[catIndex] = {};

              // Sales rows
              category.salesRows.forEach((row, rowIndex) => {
                initialSalesInputValues[catIndex][rowIndex] = row.chargecode || "";
                initialSelectedSalesChargeIds[`${catIndex}_${rowIndex}`] = row.charge_id || 0;
              });

              // Cost rows
              category.costRows.forEach((row, rowIndex) => {
                initialCostInputValues[catIndex][rowIndex] = row.chargecode || "";
                initialSelectedCostChargeIds[`${catIndex}_${rowIndex}`] = row.charge_id || 0;
              });
            });

            setSalesInputValues(initialSalesInputValues);
            setCostInputValues(initialCostInputValues);
            setSelectedSalesChargeIds(initialSelectedSalesChargeIds);
            setSelectedCostChargeIds(initialSelectedCostChargeIds);

            const initialVendorInputValues = {};
            const initialSelectedVendorIds = {};

            mappedCategories.forEach((category, catIndex) => {
              category.costRows.forEach((row, rowIndex) => {
                const key = `${catIndex}_${rowIndex}`;
                initialVendorInputValues[key] = row.vendor_name || "";
                initialSelectedVendorIds[key] = row.vendor_id || 0;
              });
            });

            setVendorInputValues(initialVendorInputValues);
            setSelectedVendorIds(initialSelectedVendorIds);

          }
        }
      } catch (error) {
        console.error("Error loading edit data:", error);
      }
    };

    loadEditData();
  }, []);

  // For sales rows:
  const handleSalesInputChange = (e, categoryIndex, rowIndex, field) => {
    let value = e.target.value;
    if (field === "salesRemarks") {
      value = value.replace(/,/g, "");
    }

    setAllCategories(prevCategories =>
      prevCategories.map((category, currentIndex) => {
        if (currentIndex === categoryIndex) {
          const updatedRows = category.salesRows.map((row, i) => {
            if (i === rowIndex) {
              const updatedRow = { ...row, [field]: value };

              if (field === 'SalesunitQuantity' || field === 'salesRate') {
                const salesQuantity = parseFloat(updatedRow.SalesunitQuantity) || 0;
                const salesRate = parseFloat(updatedRow.salesRate) || 0;
                updatedRow.salesNetTotal = (salesQuantity * salesRate).toFixed(2);
              }

              return updatedRow;
            }
            return row;
          });

          // Recalculate category totals
          const salesTotal = updatedRows.reduce((sum, row) => sum + (parseFloat(row.salesNetTotal) || 0), 0);
          const costTotal = category.costRows.reduce((sum, row) => sum + (parseFloat(row.costNetTotal) || 0), 0);
          const profitAmount = salesTotal - costTotal;
          const profitPercent = costTotal > 0 ? ((profitAmount / costTotal) * 100).toFixed(2) : '0.00';

          return {
            ...category,
            salesRows: updatedRows,
            salesNetTotal: salesTotal.toFixed(2),
            costNetTotal: costTotal.toFixed(2),
            profitAmount: profitAmount.toFixed(2),
            profitPercent
          };
        }
        return category;
      })
    );
  };

  // For cost rows:
  const handleCostInputChange = (e, categoryIndex, rowIndex, field) => {
    let value = e.target.value;

    if (field === "costRemarks") {
      value = value.replace(/,/g, "");
    }
    setAllCategories(prevCategories =>
      prevCategories.map((category, currentIndex) => {
        if (currentIndex === categoryIndex) {
          const updatedRows = category.costRows.map((row, i) => {
            if (i === rowIndex) {
              const updatedRow = { ...row, [field]: value };

              if (field === 'CostunitQuantity' || field === 'costRate') {
                const costQuantity = parseFloat(updatedRow.CostunitQuantity) || 0;
                const costRate = parseFloat(updatedRow.costRate) || 0;
                updatedRow.costNetTotal = (costQuantity * costRate).toFixed(2);
              }

              return updatedRow;
            }
            return row;
          });

          // Recalculate category totals
          const salesTotal = category.salesRows.reduce((sum, row) => sum + (parseFloat(row.salesNetTotal) || 0), 0);
          const costTotal = updatedRows.reduce((sum, row) => sum + (parseFloat(row.costNetTotal) || 0), 0);
          const profitAmount = salesTotal - costTotal;
          const profitPercent = costTotal > 0 ? ((profitAmount / costTotal) * 100).toFixed(2) : '0.00';

          return {
            ...category,
            costRows: updatedRows,
            salesNetTotal: salesTotal.toFixed(2),
            costNetTotal: costTotal.toFixed(2),
            profitAmount: profitAmount.toFixed(2),
            profitPercent
          };
        }
        return category;
      })
    );
  };


  // const [showPopup, setShowPopup] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState('');

  const handleDayClick = (day) => {
    setActiveDay(day);
  };

  // Handle form input changes
  const handleFormInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleprojectInputChange = (e) => {
    const value = e.target.value;
    const filtered = projectOptions.filter(project =>
      project.name.toLowerCase().includes(value.toLowerCase())
    );

    setFormData({ ...formData, project_name: value, project_id: '' });
    setFilteredProjects(filtered);
    setShowSuggestions(true);
  };

  const handleProjectSelect = (project) => {
    setFormData({
      ...formData,
      project_id: project.value,
      project_name: project.label,
    });
    setShowSuggestions(false);
  };

  const isPeriodSettingUsed = () => {
    return Object.keys(jobTypeSchedules).length > 0;
  };

  const handleSubmit = async (action) => {
    if (isSaving || isSubmitting) return;
    if (!projectInput.trim()) {
      toast.error("Project Code is required");
      return;
    }
    if (selectedJobs.length === 0) {
      toast.error("At least one Job Type is required");
      return;
    }

    if (!validateMailBeforeSubmit()) return;

    if (isPeriodSettingUsed() && !formData.contract_mail?.trim()) {
      toast.error("Mail ID is mandatory for contract scheduling.");
      return;
    }

    const jobTypes = [];
    const jobTypePeriods = [];

    allCategories.forEach((category, categoryIndex) => {
      const jobTypeId = parseInt(category.id) || 0;

      const salesLines = category.salesRows
        .filter(row => row.description.trim() !== "" || row.SalesunitQuantity.trim() !== "" || row.salesRate.trim() !== "")
        .map((row, index) => ({
          charge_id: selectedSalesChargeIds[`${categoryIndex}_${index}`] || 0,
          description_of_charges: row.description || "",
          unit_of_quantity: parseFloat(row.SalesunitQuantity) || 0,
          unit_of_rate: parseFloat(row.salesRate) || 0,
          net_total: parseFloat(row.salesNetTotal) || 0,
          charge_code: row.chargecode || "",
          elements: row.elements || "",
          remarks: row.salesRemarks || "",
          po_wo_number: row.po_wo_number || null,
          po_wo_date: row.po_wo_date || null,
        }));

      const costLines = category.costRows
        .filter(row => row.description.trim() !== "" || row.CostunitQuantity.trim() !== "" || row.costRate.trim() !== "")
        .map((row, index) => ({
          charge_id: selectedCostChargeIds[`${categoryIndex}_${index}`] || 0,
          description_of_charges: row.description || "",
          unit_of_quantity: parseFloat(row.CostunitQuantity) || 0,
          unit_of_rate: parseFloat(row.costRate) || 0,
          net_total: parseFloat(row.costNetTotal) || 0,
          charge_code: row.chargecode || "",
          elements: row.elements || "",
          remarks: row.costRemarks || "",
          vendor_id: selectedVendorIds[`${categoryIndex}_${index}`] || 0,
          po_wo_number: row.po_wo_number || null,
          po_wo_date: row.po_wo_date || null,
        }));

      jobTypes.push({
        project_id: parseInt(selectedproject) || 0,
        job_type_id: jobTypeId,
        chargelines: {
          sales: salesLines,
          cost: costLines
        }
      });

      // Get scheduling info from jobTypeSchedules
      const schedule = jobTypeSchedules[jobTypeId];
      if (schedule) {
        const { triggerStartDate, triggerEndDate } = schedule;
        if (schedule.periodType === "weekly") {
          jobTypePeriods.push({
            job_type_id: jobTypeId,
            period_type: "weekly",
            week_once: schedule.weeklyInterval,
            // week_days: schedule.weeklyDay.charAt(0).toUpperCase() + schedule.weeklyDay.slice(1, 3), // "Mon", "Tue", etc.
            week_days: schedule.weeklyDay,
            // week_start_date: formData.contract_start_date
            week_start_date: triggerStartDate || formData.contract_start_date,
            week_end_date: triggerEndDate || formData.contract_expiry_date
          });
        } else if (schedule.periodType === "monthly") {
          jobTypePeriods.push({
            job_type_id: jobTypeId,
            period_type: "monthly",
            month_date: parseInt(schedule.monthlyDay),
            month_period: parseInt(schedule.monthlyInterval),
            // month_start_date: formData.contract_start_date,
            month_start_date: triggerStartDate || formData.contract_start_date,
            month_end_date: triggerEndDate || formData.contract_expiry_date
          });
        }
      }
    });

    const submitData = {
      project_id: parseInt(selectedproject) || 0,
      contract_start_date: formData.contract_start_date || null,
      contract_expiry_date: formData.contract_expiry_date || null,
      contract_mail: formData.contract_mail,
      supply_period_start_day: formData.supply_period_start_day,
      supply_period_end_day: formData.supply_period_end_day,
      job_type: jobTypes,
      job_type_period: jobTypePeriods
    };

    console.log("Submit Data:", JSON.stringify(submitData, null, 2));

    if (action === "save") {
      setIsSaving(true);
    } else {
      setIsSubmitting(true);
    }

    try {
      const response = await axiosInstance.post('/contract/save', submitData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.data.success) {
        toast.success("Contract Saved Successfully!");
        setTimeout(() => {
          navigate("/contract");
        }, 1500);
      } else {
        throw new Error(response.data.message || "Failed to save contract");
      }
    } catch (error) {
      console.error("save error:", error);
      toast.error(error.message || "Failed to save contract");
    } finally {
      setIsSaving(false);
      setIsSubmitting(false);
    }
  };


  const handleUpdate = async (action) => {
    if (isSaving || isSubmitting) return;
    if (!projectInput.trim()) {
      toast.error("Project Code is required");
      return;
    }

    if (!validateMailBeforeSubmit()) return;

    if (isPeriodSettingUsed() && !formData.contract_mail?.trim()) {
      toast.error("Mail ID is mandatory for contract scheduling.");
      return;
    }

    const jobTypes = [];
    const jobTypePeriods = [];

    allCategories.forEach((category, categoryIndex) => {
      const jobTypeId = parseInt(category.id) || 0;

      // Prepare chargelines
      const salesLines = category.salesRows
        .filter(row =>
          row.description.trim() !== "" || row.SalesunitQuantity.trim() !== "" || row.salesRate.trim() !== ""
        )
        .map((row, index) => ({
          charge_id: selectedSalesChargeIds[`${categoryIndex}_${index}`] || 0,
          contract_charge_line_table_id: row.contract_charge_line_table_id
            ? parseInt(row.contract_charge_line_table_id)
            : null,
          description_of_charges: row.description || "",
          unit_of_quantity: parseFloat(row.SalesunitQuantity) || 0,
          unit_of_rate: parseFloat(row.salesRate) || 0,
          net_total: parseFloat(row.salesNetTotal) || 0,
          charge_code: row.chargecode || "",
          elements: row.elements || "",
          remarks: row.salesRemarks || "",
          po_wo_number: row.po_wo_number || null,
          po_wo_date: row.po_wo_date || null,
        }));

      const costLines = category.costRows
        .filter(row =>
          row.description.trim() !== "" || row.CostunitQuantity.trim() !== "" || row.costRate.trim() !== "")
        .map((row, index) => ({
          charge_id: selectedCostChargeIds[`${categoryIndex}_${index}`] || 0,
          contract_charge_line_table_id: row.contract_charge_line_table_id
            ? parseInt(row.contract_charge_line_table_id)
            : null,
          description_of_charges: row.description || "",
          unit_of_quantity: parseFloat(row.CostunitQuantity) || 0,
          unit_of_rate: parseFloat(row.costRate) || 0,
          net_total: parseFloat(row.costNetTotal) || 0,
          charge_code: row.chargecode || "",
          elements: row.elements || "",
          remarks: row.costRemarks || "",
          vendor_id: selectedVendorIds[`${categoryIndex}_${index}`] || 0,
          po_wo_number: row.po_wo_number || null,
          po_wo_date: row.po_wo_date || null,
        }));


      jobTypes.push({
        contract_job_table_id: parseInt(category.contract_job_table_id) || 0,
        project_id: parseInt(selectedproject) || 0,
        job_type_id: jobTypeId,
        chargelines: {
          sales: salesLines,
          cost: costLines
        }
      });

      // Period logic from schedule
      const schedule = jobTypeSchedules[jobTypeId];
      if (schedule) {
        const { triggerStartDate, triggerEndDate } = schedule;
        if (schedule.periodType === "weekly") {
          jobTypePeriods.push({
            job_type_id: jobTypeId,
            period_type: "weekly",
            week_once: schedule.weeklyInterval,
            week_days: schedule.weeklyDay.charAt(0).toUpperCase() + schedule.weeklyDay.slice(1, 3), // "Mon"
            // week_start_date: formData.contract_start_date
            week_start_date: triggerStartDate || formData.contract_start_date,
            week_end_date: triggerEndDate || formData.contract_expiry_date
          });
        } else if (schedule.periodType === "monthly") {
          jobTypePeriods.push({
            job_type_id: jobTypeId,
            period_type: "monthly",
            month_date: parseInt(schedule.monthlyDay),
            month_period: parseInt(schedule.monthlyInterval),
            // month_start_date: formData.contract_start_date
            month_start_date: triggerStartDate || formData.contract_start_date,
            month_end_date: triggerEndDate || formData.contract_expiry_date
          });
        }
      }
    });

    const submitData = {
      id: contractId || 0,
      project_id: parseInt(selectedproject) || 0,
      contract_start_date: formData.contract_start_date  || null,
      contract_expiry_date: formData.contract_expiry_date || null,
      contract_code: formData.contract_code,
      contract_mail: formData.contract_mail,
      supply_period_start_day: formData.supply_period_start_day,
      supply_period_end_day: formData.supply_period_end_day,
      job_type: jobTypes,
      job_type_period: jobTypePeriods,
      deleted_job_type_ids: deletedJobTypeIds,
      deleted_line_ids: {
        sales: deletedSalesLineIds,
        cost: deletedCostLineIds,
      },
    };

    console.log("Updating data:", JSON.stringify(submitData, null, 2));

    if (action === "save") {
      setIsSaving(true);
    } else {
      setIsSubmitting(true);
    }

    try {
      const response = await axiosInstance.put(
        '/contract/update',
        submitData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data.success) {
        toast.success("Contract Updated Successfully!");
        setDeletedJobTypeIds([]);
        setDeletedSalesLineIds([]);
        setDeletedCostLineIds([]);
        setTimeout(() => {
          navigate("/contract");
        }, 1500);
      } else {
        throw new Error(response.data.message || "Failed to update contract");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error(error.message || "Failed to update contract");
    } finally {
      setIsSaving(false);
      setIsSubmitting(false);
    }
  };


  useEffect(() => {
    const fetchJobs = async () => {
      try {
        // const response = await axios.get(`https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/project_based/getJobTypes/${projectId}`); // Replace with your actual API
        const response = await axiosInstance.get(`/project_based/getJobTypes/${projectId}`);

        console.log(response.data.jobtypes)
        if (response.data && Array.isArray(response.data.jobtypes)) {
          console.log("jobtypecalled");
          console.log(response.data)
          setJobOptions(response.data.jobtypes); // Directly using response since it has label + value
        }
      } catch (error) {
        console.error("Failed to fetch job options:", error);
      }
    };

    fetchJobs();
  }, [projectId]);


  // Toggle dropdown visibility
  const toggleJobDropdown = () => {
    setIsJobDropdownOpen(!isJobDropdownOpen);
  };

  // Handle job selection
  const handleJobCheckboxChange = (jobId) => {
    setSelectedJobs(prev =>
      prev.includes(jobId)
        ? prev.filter(id => id !== jobId)
        : [...prev, jobId]
    );
    setPeriodJobs(prev =>
      prev.includes(jobId)
        ? prev.filter(id => id !== jobId)
        : [...prev, jobId]
    );
  };

  const handleRemoveJob = (jobId) => {
    const removedIndex = allCategories.findIndex(cat => cat.id === jobId);
    if (removedIndex === -1) return;

    if (isEdit) {
      const removedCategory = allCategories[removedIndex];
      if (removedCategory?.contract_job_table_id) {
        setDeletedJobTypeIds(prev => [...prev, removedCategory.contract_job_table_id]);
      }
    }

    const newSelectedJobs = selectedJobs.filter(id => id !== jobId);
    const newPeriodJobs = periodJobs.filter(id => id !== jobId);

    setSelectedJobs(newSelectedJobs);
    setPeriodJobs(newPeriodJobs);

    setAllCategories(prevCategories =>
      prevCategories.filter(category => category.id !== jobId)
    );

    const reindexState = (prevState) => {
      const newState = {};
      Object.keys(prevState).forEach(key => {
        const catIndex = Number(key);
        if (catIndex < removedIndex) {
          newState[catIndex] = prevState[catIndex];
        } else if (catIndex > removedIndex) {
          newState[catIndex - 1] = prevState[catIndex];
        }
      });
      return newState;
    };

    const reindexKeyedState = (prevState) => {
      const newState = {};
      Object.keys(prevState).forEach(key => {
        const [catIndexStr, rowIdxStr] = key.split('_');
        const catIndex = Number(catIndexStr);

        if (catIndex < removedIndex) {
          newState[key] = prevState[key];
        } else if (catIndex > removedIndex) {
          newState[`${catIndex - 1}_${rowIdxStr}`] = prevState[key];
        }
      });
      return newState;
    };

    setInputValues(prev => reindexState(prev));
    setSelectedChargeIds(prev => reindexKeyedState(prev));

    setSalesInputValues(prev => reindexState(prev));
    setSelectedSalesChargeIds(prev => reindexKeyedState(prev));

    setCostInputValues(prev => reindexState(prev));
    setSelectedCostChargeIds(prev => reindexKeyedState(prev));

    setVendorInputValues(prev => reindexKeyedState(prev));
    setSelectedVendorIds(prev => reindexKeyedState(prev));
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsJobDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const [uploadedFiles, setUploadedFiles] = useState([]);

  const [inputValue, setInputValue] = useState("");
  const [suggestionsMap, setSuggestionsMap] = useState({});
  const [showSuggestionsMap, setShowSuggestionsMap] = useState({});
  const [inputValues, setInputValues] = useState({});
  const [showProjectSuggestions, setShowProjectSuggestions] = useState(false);
  const [projectOptions, setProjectOptions] = useState([]);
  const [projectInput, setProjectInput] = useState("");
  const [selectedproject, setselectedproject] = useState(0);

  const handleSelect = (value) => {
    console.log("Selected value:", value);
  };

  useEffect(() => {
    axiosInstance
      // .get("https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/costsolution/projects/autosuggestion")
      .get("/costsolution/projects/autosuggestion")

      .then((response) => {
        setProjectOptions(response.data || []);
      })
      .catch((error) => {
        console.error("Error fetching projects:", error);
      });
  }, []);

  useEffect(() => {
    setAllCategories(prevCategories => {
      const updatedCategories = [...prevCategories];

      selectedJobs.forEach((jobValue) => {
        const alreadyExists = updatedCategories.some(cat => cat.id === jobValue);
        if (!alreadyExists) {
          let jobObject = {};

          if (contract_data.job_type && !hasProjectChanged) {
            const job = contract_data.job_type.find(job => job.job_type_id === jobValue);
            if (job) {
              jobObject = {
                id: job.job_type_id,
                name: job.job_type_name || "Category 1",
                quantity: job.quantity || '-',
                rate: job.rate || '-',
                netValue: job.netValue || '-',
                salesRows: job.chargelines.length > 0 ? job.chargelines.map(line => ({
                  chargeCode: "",
                  description: line.description_of_charges || "",
                  salesRemarks: line.remarks || "",
                  SalesunitQuantity: line.sales_unit_of_quantity || "",
                  salesRate: line.unit_of_rate || "",
                  salesNetTotal: line.net_total || "",
                  isSales: true
                })) : [
                  {
                    chargeCode: "",
                    description: "",
                    salesRemarks: "",
                    SalesunitQuantity: "",
                    salesRate: "",
                    salesNetTotal: "",
                    isSales: true
                  }
                ],
                costRows: job.chargelines.length > 0 ? job.chargelines.map(line => ({
                  chargeCode: "",
                  description: line.description_of_charges || "",
                  costRemarks: line.remarks || "",
                  CostunitQuantity: line.cost_unit_of_quantity || "",
                  costRate: line.unit_of_rate || "",
                  costNetTotal: line.net_total || "",
                  isSales: false
                })) : [
                  {
                    chargeCode: "",
                    description: "",
                    costRemarks: "",
                    CostunitQuantity: "",
                    costRate: "",
                    costNetTotal: "",
                    isSales: false
                  }
                ]
              };
            }
          }

          if (!jobObject.id) {
            jobObject = {
              id: jobValue,
              name: "Category " + jobValue,
              quantity: "-",
              rate: "-",
              netValue: "-",
              salesRows: [
                {
                  chargeCode: "",
                  description: "",
                  salesRemarks: "",
                  SalesunitQuantity: "",
                  salesRate: "",
                  salesNetTotal: "",
                  isSales: true
                }
              ],
              costRows: [
                {
                  chargeCode: "",
                  description: "",
                  costRemarks: "",
                  CostunitQuantity: "",
                  costRate: "",
                  costNetTotal: "",
                  isSales: false
                }
              ]
            };
          }

          updatedCategories.push(jobObject);
        }
      });

      const filtered = updatedCategories.filter(cat => selectedJobs.includes(cat.id));

      return filtered;
    });
  }, [selectedJobs]);



  const addSalesRow = (chargeindex) => {
    setAllCategories(prevCategories =>
      prevCategories.map((category, index) =>
        index === chargeindex
          ? {
            ...category,
            salesRows: [
              ...category.salesRows,
              {
                chargeCode: '',
                description: '',
                po_wo_number: '',
                po_wo_date: '',
                salesRemarks: '',
                SalesunitQuantity: '',
                salesRate: '',
                salesNetTotal: '',
                isSales: true
              },
            ],
          }
          : category
      )
    );
  };

  const addCostRow = (chargeindex) => {
    setAllCategories(prevCategories =>
      prevCategories.map((category, index) =>
        index === chargeindex
          ? {
            ...category,
            costRows: [
              ...category.costRows,
              {
                chargeCode: '',
                description: '',
                po_wo_number: '',
                po_wo_date: '',
                costRemarks: '',
                CostunitQuantity: '',
                costRate: '',
                costNetTotal: '',
                isSales: false
              },
            ],
          }
          : category
      )
    );
  };


  const handleFileUpload = (e, categoryId, rowIndex) => {
    const files = Array.from(e.target.files);

    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: category.rows.map((row, i) =>
              i === rowIndex ? { ...row, uploadedFiles: [...(row.uploadedFiles || []), ...files] } : row
            ),
          }
          : category
      )
    );
  };

  const handleRemoveFile = (categoryId, rowIndex, fileIndex) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: category.rows.map((row, i) =>
              i === rowIndex
                ? {
                  ...row,
                  uploadedFiles: row.uploadedFiles.filter((_, index) => index !== fileIndex),
                }
                : row
            ),
          }
          : category
      )
    );
  };


  const handleCheckboxChange = (e, categoryId, index) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: category.rows.map((row, i) =>
              i === index ? { ...row, isChecked: e.target.checked } : row
            ),
          }
          : category
      )
    );
  };
  // Separate fetch functions
  const fetchSalesSuggestions = async (searchTerm = "", rowIndex, index) => {
    try {
      const response = await axiosInstance.get(
        `/getnonprojectsaleschargecodes`,
        { params: { term: searchTerm } }
      );

      if (response.data?.chargecodes) {
        setSalesSuggestionsMap(prev => {
          const updated = { ...prev };
          if (!updated[index]) updated[index] = {};
          updated[index][rowIndex] = response.data.chargecodes;
          return updated;
        });

        setShowSalesSuggestionsMap(prev => ({
          ...prev,
          [`${index}_${rowIndex}`]: true,
        }));
      }
    } catch (err) {
      console.error("Failed to fetch sales suggestions", err);
      setSalesSuggestionsMap(prev => {
        const updated = { ...prev };
        if (!updated[index]) updated[index] = {};
        updated[index][rowIndex] = [];
        return updated;
      });
    }
  };

  // Similar function for cost suggestions
  const fetchCostSuggestions = async (searchTerm = "", rowIndex, index) => {
    try {
      const response = await axiosInstance.get(
        `/getnonprojectcostchargecodes`,
        { params: { term: searchTerm } }
      );

      if (response.data?.chargecodes) {
        setCostSuggestionsMap(prev => {
          const updated = { ...prev };
          if (!updated[index]) updated[index] = {};
          updated[index][rowIndex] = response.data.chargecodes;
          return updated;
        });

        setShowCostSuggestionsMap(prev => ({
          ...prev,
          [`${index}_${rowIndex}`]: true,
        }));
      }
    } catch (err) {
      console.error("Failed to fetch cost suggestions", err);
      setCostSuggestionsMap(prev => {
        const updated = { ...prev };
        if (!updated[index]) updated[index] = {};
        updated[index][rowIndex] = [];
        return updated;
      });
    }
  };
  const fetchProjectSuggestions = async (query, rowIndex) => {
    try {
      setSuggestionsMap([]);
      // const response = await axios.get("https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/costsolution/projects/autosuggestion", { query });
      const response = await axiosInstance.get("/costsolution/projects/autosuggestion", { query });

      // Example structure: { autosuggestion: [ { label: '', value: '' }, ... ] }
      if (response.data?.autosuggestion) {
        const newSuggestions = response.data?.autosuggestion || [];
        setProjectOptions(newSuggestions);
        setShowProjectSuggestions(true);
      }
    } catch (err) {
      console.error("Failed to fetch suggestions", err);
      // setProjectOptions({[]});
      // setShowSuggestionsMap(prev => ({ ...prev, [rowIndex]: false }));
    }
  };

  const deleteRow = (categoryId, rowIndex, rowType) => {
    const categoryIndex = allCategories.findIndex(cat => cat.id === categoryId);

    if (categoryIndex === -1) {
      return;
    }

    const category = allCategories[categoryIndex];

    // Check if we're deleting from sales or cost rows
    const isSalesRow = rowType === 'sales';
    const targetRows = isSalesRow ? category.salesRows : category.costRows;

    if (targetRows.length <= 1) {
      toast.error("At least one row must remain, cannot delete.");
      return;
    }

    if (isEdit) {
      const deletedRow = targetRows[rowIndex];
      if (deletedRow?.contract_charge_line_table_id) {
        if (isSalesRow) {
          setDeletedSalesLineIds(prev => [...prev, deletedRow.contract_charge_line_table_id]);
        } else {
          setDeletedCostLineIds(prev => [...prev, deletedRow.contract_charge_line_table_id]);
        }
      }
    }

    setAllCategories(prevCategories =>
      prevCategories.map(cat => {
        if (cat.id === categoryId) {
          // Create new arrays without the deleted row
          const newSalesRows = isSalesRow
            ? [...cat.salesRows].filter((_, i) => i !== rowIndex)
            : [...cat.salesRows];

          const newCostRows = !isSalesRow
            ? [...cat.costRows].filter((_, i) => i !== rowIndex)
            : [...cat.costRows];

          // Calculate new totals
          const salesNetTotal = newSalesRows.reduce((sum, row) => sum + (parseFloat(row.salesNetTotal) || 0), 0);
          const costNetTotal = newCostRows.reduce((sum, row) => sum + (parseFloat(row.costNetTotal) || 0), 0);
          const profitAmount = salesNetTotal - costNetTotal;
          const profitPercent = costNetTotal > 0
            ? ((profitAmount / costNetTotal) * 100).toFixed(2)
            : '0.00';

          return {
            ...cat,
            salesRows: newSalesRows,
            costRows: newCostRows,
            salesNetTotal: salesNetTotal.toFixed(2),
            costNetTotal: costNetTotal.toFixed(2),
            profitAmount: profitAmount.toFixed(2),
            profitPercent
          };
        }
        return cat;
      })
    );

    // Update input values state
    if (isSalesRow) {
      setSalesInputValues(prevInputValues => {
        const newInputValues = { ...prevInputValues };
        if (newInputValues[categoryIndex]) {
          const rows = { ...newInputValues[categoryIndex] };
          delete rows[rowIndex];
          const shiftedRows = {};
          Object.keys(rows).forEach(key => {
            const keyNum = Number(key);
            shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
          });
          newInputValues[categoryIndex] = shiftedRows;
        }
        return newInputValues;
      });

      setSelectedSalesChargeIds(prevSelectedChargeIds => {
        const newSelectedChargeIds = {};
        Object.keys(prevSelectedChargeIds).forEach(key => {
          const [catIndexStr, rowIdxStr] = key.split('_');
          const catIndex = Number(catIndexStr);
          const rowIdx = Number(rowIdxStr);

          if (catIndex === categoryIndex) {
            if (rowIdx < rowIndex) {
              newSelectedChargeIds[key] = prevSelectedChargeIds[key];
            } else if (rowIdx > rowIndex) {
              newSelectedChargeIds[`${catIndex}_${rowIdx - 1}`] = prevSelectedChargeIds[key];
            }
          } else {
            newSelectedChargeIds[key] = prevSelectedChargeIds[key];
          }
        });
        return newSelectedChargeIds;
      });
    } else {
      setCostInputValues(prevInputValues => {
        const newInputValues = { ...prevInputValues };
        if (newInputValues[categoryIndex]) {
          const rows = { ...newInputValues[categoryIndex] };
          delete rows[rowIndex];
          const shiftedRows = {};
          Object.keys(rows).forEach(key => {
            const keyNum = Number(key);
            shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
          });
          newInputValues[categoryIndex] = shiftedRows;
        }
        return newInputValues;
      });

      setSelectedCostChargeIds(prevSelectedChargeIds => {
        const newSelectedChargeIds = {};
        Object.keys(prevSelectedChargeIds).forEach(key => {
          const [catIndexStr, rowIdxStr] = key.split('_');
          const catIndex = Number(catIndexStr);
          const rowIdx = Number(rowIdxStr);

          if (catIndex === categoryIndex) {
            if (rowIdx < rowIndex) {
              newSelectedChargeIds[key] = prevSelectedChargeIds[key];
            } else if (rowIdx > rowIndex) {
              newSelectedChargeIds[`${catIndex}_${rowIdx - 1}`] = prevSelectedChargeIds[key];
            }
          } else {
            newSelectedChargeIds[key] = prevSelectedChargeIds[key];
          }
        });
        return newSelectedChargeIds;
      });

      // Update vendor-related states for cost rows
      setVendorInputValues(prevVendorInputValues => {
        const newVendorInputValues = {};
        Object.keys(prevVendorInputValues).forEach(key => {
          const [catIndexStr, rowIdxStr] = key.split('_');
          const catIndex = Number(catIndexStr);
          const rowIdx = Number(rowIdxStr);

          if (catIndex === categoryIndex) {
            if (rowIdx < rowIndex) {
              newVendorInputValues[key] = prevVendorInputValues[key];
            } else if (rowIdx > rowIndex) {
              newVendorInputValues[`${catIndex}_${rowIdx - 1}`] = prevVendorInputValues[key];
            }
          } else {
            newVendorInputValues[key] = prevVendorInputValues[key];
          }
        });
        return newVendorInputValues;
      });

      setSelectedVendorIds(prevSelectedVendorIds => {
        const newSelectedVendorIds = {};
        Object.keys(prevSelectedVendorIds).forEach(key => {
          const [catIndexStr, rowIdxStr] = key.split('_');
          const catIndex = Number(catIndexStr);
          const rowIdx = Number(rowIdxStr);

          if (catIndex === categoryIndex) {
            if (rowIdx < rowIndex) {
              newSelectedVendorIds[key] = prevSelectedVendorIds[key];
            } else if (rowIdx > rowIndex) {
              newSelectedVendorIds[`${catIndex}_${rowIdx - 1}`] = prevSelectedVendorIds[key];
            }
          } else {
            newSelectedVendorIds[key] = prevSelectedVendorIds[key];
          }
        });
        return newSelectedVendorIds;
      });
    }

    // Update suggestions map
    setSuggestionsMap(prev => {
      const newMap = { ...prev };
      if (newMap[categoryIndex]) {
        const rows = { ...newMap[categoryIndex] };
        delete rows[rowIndex];
        const shiftedRows = {};
        Object.keys(rows).forEach(key => {
          const keyNum = Number(key);
          shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
        });
        newMap[categoryIndex] = shiftedRows;
      }
      return newMap;
    });
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsJobDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // useEffect(() => {
  //   const defaultJobId = "83939930"; // or jobOptions[0].id
  //   setSelectedJobs([defaultJobId]);
  // }, []);

  const calculateCategoryTotals = (category) => {
    const totals = {
      quantity: 0,
      rate: 0,
      netValue: 0
    };

    const allRows = [...(category.salesRows || []), ...(category.costRows || [])];

    allRows.forEach(row => {
      totals.quantity += parseFloat(row.SalesunitQuantity || row.CostunitQuantity) || 0;
      totals.rate += parseFloat(row.salesRate || row.costRate) || 0;
      totals.netValue += parseFloat(row.salesNetTotal || row.costNetTotal) || 0;
    });

    return totals;
  };

  const loadProjectOptions = async (inputValue, callback) => {
    console.log("Searching for projects with:", inputValue);

    try {
      // const res = await axios.get(
      //   "https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/costsolution/projects/autosuggestion",
      //   {
      //     params: { term: inputValue || '' },
      //     headers: { "Content-Type": "application/json" },
      //   }
      // );

      const res = await axiosInstance.get(
        "/costsolution/projects/autosuggestion",
        {
          params: { term: inputValue || '' },
          headers: { "Content-Type": "application/json" },
        }
      );


      const projects = res.data?.autosuggestion || [];

      // Filter so only uppercase matching labels are returned
      const filtered = projects.filter(item =>
        item.label.toUpperCase().includes(inputValue.toUpperCase())
      );

      const mapped = filtered.map((item) => ({
        label: item.label,
        value: item.value,
      }));

      console.log("Filtered + Mapped project options:", mapped);
      callback(mapped);
    } catch (error) {
      console.error("Project suggestion error:", error);
      callback([]);
    }
  };






  const dayToCode = {
    sunday: "Sun",
    monday: "Mon",
    tuesday: "Tue",
    wednesday: "Wed",
    thursday: "Thu",
    friday: "Fri",
    saturday: "Sat",
  };

  const weekMap = {
    first: 1,
    second: 2,
    third: 3,
    fourth: 4,
    last: 5,
  };

  // Returns the next date (as string YYYY-MM-DD) for the given day name
  const getNextWeekdayDate = (dayName) => {
    const today = new Date();
    const dayIndex = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"].indexOf(dayName.toLowerCase());
    const diff = (dayIndex + 7 - today.getDay()) % 7;
    const nextDate = new Date(today);
    nextDate.setDate(today.getDate() + diff);
    return nextDate.toISOString().split("T")[0];
  };





  const handleSave = () => {
    const newSchedule = {
      periodType: selectedPeriod,
      triggerStartDate,
      triggerEndDate
    };

    if (selectedPeriod === "weekly") {
      newSchedule.weeklyInterval = Number(weeklyInterval);
      newSchedule.weeklyDay = activeDay;
    } else {
      newSchedule.monthlyInterval = Number(monthlyInterval);
      newSchedule.monthlyDay = Number(monthlyDay);
    }

    if (jobTypeBeingScheduled) {
      // For single job type from 📅 icon
      setJobTypeSchedules(prev => ({
        ...prev,
        [jobTypeBeingScheduled]: newSchedule,
      }));
    } else {
      // For all selected checkboxes
      setJobTypeSchedules(prev => {
        const updated = { ...prev };
        periodJobs.forEach(jobId => {
          updated[jobId] = newSchedule;
        });
        return updated;
      });
      // Update display for bulk scheduling
      setSelectedDateRange(getReadableSchedule(newSchedule));
    }

    // Cleanup
    setJobTypeBeingScheduled(null);
    setShowPopup(false);
  };

  const getNextTriggerDate = () => {
    let startDate = new Date(triggerStartDate);
    let endDate = new Date(triggerEndDate);
    const today = new Date();
    
    // Normalize dates (remove time portion for comparison)
    today.setHours(0, 0, 0, 0);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    if (isNaN(startDate.getTime())) startDate = new Date(today);
    if (isNaN(endDate.getTime())) endDate = new Date("9999-12-31");

    // Return empty if range already expired
    if (today > endDate) return "";

    // Determine calculation start date
    const calcStartDate = today < startDate ? new Date(startDate) : new Date(today);

    if (selectedPeriod === "weekly") {
      const targetDay = weekDays.findIndex(d => d.value === activeDay);
      let nextDate = new Date(calcStartDate);
      const currentDay = nextDate.getDay();
      const diffToTarget = (targetDay - currentDay + 7) % 7;

      nextDate.setDate(nextDate.getDate() + diffToTarget);

      // If it's today and we already passed it, or if we got 0 days diff, add interval
      if (nextDate <= calcStartDate || (diffToTarget === 0 && calcStartDate.getDay() === targetDay && calcStartDate > today)) {
        // Already on target day, move forward by interval
        nextDate.setDate(nextDate.getDate() + weeklyInterval * 7);
      }

      return nextDate <= endDate ? nextDate.toDateString() : "";
    }

    if (selectedPeriod === "monthly") {
      const targetDay = Math.min(parseInt(monthlyDay) || 1, 31);
      const interval = parseInt(monthlyInterval) || 1;

      let nextDate = new Date(calcStartDate);
      nextDate.setDate(targetDay);

      // If the target day in current/start month hasn't occurred yet, use it
      // Otherwise, add interval and set to target day
      if (nextDate < calcStartDate) {
        nextDate.setMonth(nextDate.getMonth() + interval);
        nextDate.setDate(targetDay);
      }

      // Fix month overflow (e.g., Feb 30 -> Feb 28/29)
      while (nextDate.getDate() !== targetDay && nextDate.getDate() > 0) {
        nextDate.setDate(nextDate.getDate() - 1);
      }

      return nextDate <= endDate ? nextDate.toDateString() : "";
    }

    return "";
  };


  const fetchVendorSuggestions = async (searchTerm = "") => {
    try {
      const response = await axiosInstance.get(
        "/vendor/autosuggestion",
        { params: { term: searchTerm } }
      );
      return response.data?.autosuggestion || [];
    } catch (error) {
      console.error("Failed to fetch vendor suggestions:", error);
      return [];
    }
  };

  const handleViewModeChange = (categoryId, mode) => {
    setViewModes(prev => ({
      ...prev,
      [categoryId]: mode
    }));
  };

  const getViewModeForCategory = (categoryId) => {
    return viewModes[categoryId] || "split";
  };

  const openRemarkPopup = (type, rowIndex, lineIndex, value) => {
    setRemarkMeta({ type, rowIndex, lineIndex });
    setRemarkValue(value || "");
    setShowRemarkPopup(true);
  };

  const handleSaveRemark = (updatedValue) => {
    if (!remarkMeta) return;

    const { type, rowIndex, lineIndex } = remarkMeta;

    if (type === "sales") {
      handleSalesInputChange(
        { target: { value: updatedValue } },
        rowIndex,
        lineIndex,
        "salesRemarks"
      );
    } else if (type === "cost") {
      handleCostInputChange(
        { target: { value: updatedValue } },
        rowIndex,
        lineIndex,
        "costRemarks"
      );
    }

    setShowRemarkPopup(false);
  };

  const handleSupplyDayChange = (e) => {
    const { value } = e.target;

    if (value === "") {
      setFormData(prev => ({
        ...prev,
        supply_period_start_day: "",
        supply_period_end_day: ""
      }));
      return;
    }

    const startDay = Number(value);

    if (startDay < 1 || startDay > 31) {
      toast.warning("Day must be between 1 and 31");
      return;
    }

    const endDay = startDay === 1 ? 31 : startDay - 1;

    setFormData(prev => ({
      ...prev,
      supply_period_start_day: startDay,
      supply_period_end_day: endDay
    }));
  };

  return (
    <>
      {isPopupOpen && (
        <div className="contracts_popup">
          <Contracts_header onSearch={null} disableSearch={true}/>
          <div className="contracts_popup_header">
            <div className="contracts_popup_header_left">
              <img src={back_arrow} alt="Back Arrow" onClick={() => navigate(-1)}
                style={{ cursor: "pointer" }} />
              <p className="new_cost_line">New Contract</p>
            </div>

            <div className="contracts_popup_header_right">
              <button className="cancel_btn" onClick={() => navigate(-1)}>Cancel</button>
              {/* <button
                className="submit_btn"
                onClick={isEdit ? handleUpdate : handleSubmit}
              >
                {isEdit ? "Update" : "Submit"}
              </button> */}
              {isEdit ? (
                <>
                  <button className="save_btn" onClick={() => handleUpdate("save")} disabled={isSaving || isSubmitting}>{isSaving ? "Saving..." : "Save"}</button>
                  <button className="submit_btn" onClick={() => handleUpdate("submit")} disabled={isSaving || isSubmitting}>{isSubmitting ? "Submitting..." : "Submit"}</button>
                </>
              ) : (
                <>
                  <button className="save_btn" onClick={() => handleSubmit("save")} disabled={isSaving || isSubmitting}>{isSaving ? "Saving..." : "Save"}</button>
                  <button className="submit_btn" onClick={() => handleSubmit("submit")} disabled={isSaving || isSubmitting}>{isSubmitting ? "Submitting..." : "Submit"}</button>
                </>
              )}
            </div>

          </div>

          <div className="contract-popup_project">
            <div className='contract-popup_all_input'>
              {/* Grid container */}
              <div className='contract-popup_grid'>
                {/* First row - 4 columns */}
                <div className='contract-popup_input_list'>
                  <p className="contract-popup_project_text">Project <span style={{ color: 'red' }}>*</span></p>
                  <div style={{ position: 'relative' }}>
                    <AsyncSelect
                      cacheOptions
                      defaultOptions
                      loadOptions={loadProjectOptions}
                      onChange={(selectedOption) => {
                        if (selectedOption) {
                          setHasProjectChanged(true);

                          setProjectInput(selectedOption.label);
                          setFormData({
                            ...formData,
                            project_id: selectedOption.value,
                            project_name: selectedOption.label
                          });
                          setselectedproject(selectedOption.value);
                          setselectedprojectId(selectedOption.value);

                          // 🔄 Clear all job-dependent data
                          setSelectedJobs([]);
                          setPeriodJobs([]);
                          setAllCategories([]);
                          setInputValues({});
                          setSelectedChargeIds({});
                        } else {
                          setProjectInput('');
                          setFormData({ ...formData, project_id: '', project_name: '' });
                          setselectedproject('');
                          setselectedprojectId('');

                          setSelectedJobs([]);
                          setPeriodJobs([]);
                          setAllCategories([]);
                          setInputValues({});
                          setSelectedChargeIds({});
                        }
                      }}

                      value={projectInput ? {
                        label: projectInput,
                        value: formData.project_id
                      } : null}
                      placeholder="Search project..."
                      isClearable
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: '44px',
                          borderRadius: '12px',
                          fontSize: '13px',
                          width: '100%',
                          borderColor: state.isFocused ? '#454CF2' : '#DCDFE4',
                          boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                          '&:hover': {
                            borderColor: '#454CF2'
                          }
                        }),
                        container: (base) => ({
                          ...base,
                          width: '100%'
                        }),
                        menu: (base) => ({
                          ...base,
                          zIndex: 999,
                          fontSize: '13px',
                          marginTop: '4px',
                          boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                        }),
                        option: (base, { isFocused }) => ({
                          ...base,
                          backgroundColor: isFocused ? '#f2f2f2' : '#fff',
                          color: '#333',
                          padding: '10px',
                          cursor: 'pointer',
                          borderBottom: '1px solid #eee',
                          '&:active': {
                            backgroundColor: '#f2f2f2'
                          }
                        }),
                        dropdownIndicator: (base) => ({
                          ...base,
                          padding: '8px'
                        }),
                        clearIndicator: (base) => ({
                          ...base,
                          padding: '8px'
                        })
                      }}
                    />
                  </div>
                </div>

                <div className="contract-popup_input_list" ref={dropdownRef}>
                  <p className="contract-popup_project_text">Jobs type <span style={{ color: 'red' }}>*</span></p>
                  <div className="contract-custom-multiselect">
                    <div className="contract-popup_dropdown" onClick={toggleJobDropdown}>
                      Select Jobs
                      <span className="dropdown-arrow">▼</span>
                    </div>
                    {isJobDropdownOpen && (
                      <div className="contract-multiselect-options">
                        {jobOptions.map(job => (
                          <label key={job.value} className="contract-multiselect-option">
                            <input
                              type="checkbox"
                              checked={selectedJobs.includes(Number(job.value))}
                              onChange={() => handleJobCheckboxChange(Number(job.value))}
                            />
                            {job.label}
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div className='contract-date'>
                  <p className="contract-popup_project_text">Start Date <span style={{ color: 'red' }}>*</span></p>
                  <div className="contract-date-input">
                    <input
                      type="date"
                      className="contract-popup-input date-input"
                      placeholder="dd-mm-yyyy"
                      name="contract_start_date"
                      value={formData.contract_start_date}
                      onChange={handleFormInputChange}
                      style={{ width: "195.33px", fontFamily: 'Work Sans' }}
                    />
                  </div>
                </div>

                <div className='contract-date'>
                  <p className="contract-popup_project_text">End Date <span style={{ color: 'red' }}>*</span></p>
                  <div className="contract-date-input">
                    <input
                      type="date"
                      className="contract-popup-input date-input"
                      placeholder="dd-mm-yyyy"
                      name="contract_expiry_date"
                      value={formData.contract_expiry_date}
                      onChange={handleFormInputChange}
                      style={{ width: "195.33px", fontFamily: 'Work Sans' }}
                    />
                  </div>
                </div>

                {/* Second row */}
                <div className='contract-popup_input_list'>
                  <p className="contract-popup_project_text">Job creation period</p>
                  <div className="custom-input-display" onClick={() => {
                    if (periodJobs.length === 0) {
                      toast.error("Please select at least one job type.");
                      return;
                    }
                    setJobTypeBeingScheduled(null);  // <-- Add this to indicate bulk scheduling mode
                    setShowPopup(true);
                    setTriggerStartDate(formData.contract_start_date);
                    setTriggerEndDate(formData.contract_expiry_date);
                    
                    // Load common schedule if all selected jobs have the same schedule
                    const allSchedules = periodJobs.map(jobId => jobTypeSchedules[jobId]).filter(s => s);
                    if (allSchedules.length === periodJobs.length && allSchedules.length > 0) {
                      const firstSchedule = allSchedules[0];
                      const allSame = allSchedules.every(s => 
                        s.periodType === firstSchedule.periodType &&
                        s.weeklyInterval === firstSchedule.weeklyInterval &&
                        s.weeklyDay === firstSchedule.weeklyDay &&
                        s.monthlyInterval === firstSchedule.monthlyInterval &&
                        s.monthlyDay === firstSchedule.monthlyDay
                      );
                      
                      if (allSame) {
                        setSelectedPeriod(firstSchedule.periodType || "weekly");
                        setWeeklyInterval(Number(firstSchedule.weeklyInterval) || 1);
                        setActiveDay(firstSchedule.weeklyDay || "Mon");
                        setMonthlyDay(Number(firstSchedule.monthlyDay) || 1);
                        setMonthlyInterval(Number(firstSchedule.monthlyInterval) || 1);
                        setTriggerStartDate(firstSchedule.triggerStartDate || formData.contract_start_date);
                        setTriggerEndDate(firstSchedule.triggerEndDate || formData.contract_expiry_date);
                      }
                    }
                  }}

                  >
                    {selectedDateRange || <span className="placeholder-text">Set time period</span>}
                  </div>
                  {showPopup && (
                    <div className="creation-popup-overlay">
                      <div className="creation-popup-box">
                        <div className="creation-popup-header">
                          <p className="popup-title">Creation Period</p>
                          <p className="popup-close" onClick={() => setShowPopup(false)}>×</p>
                        </div>

                        <div className="creation-popup-content">
                          <label className={`option-btn ${selectedPeriod === 'weekly' ? 'active' : ''}`}>
                            <input type="radio" name="period"
                              checked={selectedPeriod === 'weekly'}
                              onChange={() => setSelectedPeriod('weekly')} />
                            Weekly
                          </label>
                          <label className={`option-btn ${selectedPeriod === 'monthly' ? 'active' : ''}`}>
                            <input type="radio" name="period"
                              checked={selectedPeriod === 'monthly'}
                              onChange={() => setSelectedPeriod('monthly')} />
                            Monthly
                          </label>
                        </div>

                        {selectedPeriod === 'weekly' && (
                          <>
                            <div className="creation-popup-text">
                              <span>
                                Every
                                <input
                                  type="number"
                                  min={1}
                                  value={weeklyInterval}
                                  onChange={(e) => setWeeklyInterval(Number(e.target.value))}
                                  className="one-week"
                                  style={{ textAlign: 'center' }}
                                />
                                week(s) once
                              </span>
                            </div>

                            <div className="creation-popup-days">
                              {weekDays.map((day, index) => (
                                <button
                                  key={index}
                                  onClick={() => setActiveDay(day.value)}
                                  className={`round-circle-days ${activeDay === day.value ? 'active' : ''}`}
                                >
                                  {day.label}
                                </button>
                              ))}
                            </div>
                          </>
                        )}

                        {selectedPeriod === 'monthly' && (
                          <div className="creation-popup-monthly-wrapper">
                            <div className="creation-popup-monthly">
                              <label className="monthly-option-row">
                                <span>
                                  On the{" "}
                                  <input
                                    type="number"
                                    min={1}
                                    max={31}
                                    value={monthlyDay}
                                    onChange={(e) => setMonthlyDay(Number(e.target.value))}
                                    className="monthly-only-btn"
                                  />
                                  day, every{" "}
                                  <select
                                    value={monthlyInterval}
                                    onChange={(e) => setMonthlyInterval(Number(e.target.value))}
                                    className="monthly-dropdown"
                                  >
                                    {[...Array(12)].map((_, i) => (
                                      <option key={i + 1} value={i + 1}>
                                        {i + 1}
                                      </option>
                                    ))}
                                  </select>
                                  {monthlyInterval > 1 ? " months" : " month"}
                                </span>


                              </label>
                            </div>
                          </div>
                        )}

                        <div className="creation-popup-everyweek">
                          <span>
                            <img src={repeat_stroke_rounded} alt="" style={{ marginRight: "8px" }} />
                            {selectedPeriod === "weekly" &&
                              `Every ${weeklyInterval} week(s) on ${activeDay.charAt(0).toUpperCase() + activeDay.slice(1)}`}
                            {selectedPeriod === "monthly" && (() => {
                              const getOrdinalSuffix = (day) => {
                                const lastDigit = day % 10;
                                const lastTwoDigits = day % 100;
                                if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return 'th';
                                if (lastDigit === 1) return 'st';
                                if (lastDigit === 2) return 'nd';
                                if (lastDigit === 3) return 'rd';
                                return 'th';
                              };
                              return monthlyInterval === 1
                                ? `Monthly on ${monthlyDay}${getOrdinalSuffix(monthlyDay)}`
                                : `Once every ${monthlyInterval} months on ${monthlyDay}${getOrdinalSuffix(monthlyDay)}`;
                            })()}

                          </span>
                        </div>

                        <div className="creation-popup-trigger-range">
                          <label
                            style={{
                              fontWeight: "600",
                              fontSize: "0.92rem",
                              marginBottom: "6px",
                              display: "block"
                            }}
                          >
                            Active date range:-
                          </label>

                          <div
                            className="trigger-date-inputs"
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: "1rem",
                              flexWrap: "wrap"
                            }}
                          >
                            <div style={{ display: "flex", flexDirection: "column" }}>
                              <label style={{ fontSize: "0.85rem" }}>Start Date</label>
                              <input
                                type="date"
                                value={triggerStartDate}
                                min={formData.contract_start_date}
                                max={formData.contract_expiry_date}
                                onChange={(e) => setTriggerStartDate(e.target.value)}
                                className="date-picker"
                                style={{
                                  padding: "8px 12px",
                                  borderRadius: "10px",
                                  fontSize: "0.9rem",
                                  border: "1px solid #ccc",
                                  minWidth: "160px",
                                  fontFamily: 'Work Sans'
                                }}
                              />
                            </div>

                            <div style={{ display: "flex", flexDirection: "column" }}>
                              <label style={{ fontSize: "0.85rem" }}>End Date</label>
                              <input
                                type="date"
                                value={triggerEndDate}
                                min={formData.contract_start_date}
                                max={formData.contract_expiry_date}
                                onChange={(e) => setTriggerEndDate(e.target.value)}
                                className="date-picker"
                                style={{
                                  padding: "8px 12px",
                                  borderRadius: "10px",
                                  fontSize: "0.9rem",
                                  border: "1px solid #ccc",
                                  minWidth: "160px",
                                  fontFamily: 'Work Sans'
                                }}
                              />
                            </div>
                          </div>
                        </div>


                        <div className="creation-popup-trigger-date">
                          <span style={{ fontSize: "0.9rem", color: "#666", marginTop: "4px", display: "inline-block" }}>
                            Next Job will create on <strong>{nextTriggerDateDisplay}</strong>
                          </span>
                        </div>

                        <div className="creation-popup-button">
                          <button className="creation-cancel-btn" onClick={() => setShowPopup(false)}>Cancel</button>
                          <button className="creation-save-btn" onClick={handleSave}>Save</button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className='contract-popup_input_list'>
                  <p className="contract-popup_project_text">Mail ID</p>
                  <div className="contract-popup-input-mailid">
                    {mailTags.map((email, i) => (
                      <span className="contract-popup-input-mailid-pill" key={i}>
                        {email}
                        <button
                          type="button"
                          onClick={() => {
                            const updated = mailTags.filter((_, idx) => idx !== i);
                            setMailTags(updated);
                            setFormData(prev => ({ ...prev, contract_mail: updated.join(",") }));
                          }}
                        >
                          ×
                        </button>
                      </span>
                    ))}
                    <input
                      type="email"
                      placeholder="Add email and press Enter"
                      value={mailInput}
                      onChange={(e) => {
                        setMailInput(e.target.value);
                        setEmailError("");
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === ",") {
                          e.preventDefault();
                          const val = mailInput.trim().replace(",", "");
                          if (!val) return;
                          if (!isValidEmail(val)) {
                            setEmailError("Invalid email format");
                            return;
                          }
                          if (mailTags.includes(val)) {
                            setEmailError("Email already added");
                            return;
                          }
                          const updated = [...mailTags, val];
                          setMailTags(updated);
                          setFormData(prev => ({ ...prev, contract_mail: updated.join(",") }));
                          setMailInput("");
                          setEmailError("");
                        }
                      }}
                      onBlur={() => {
                        const val = mailInput.trim();
                        if (val && !isValidEmail(val)) {
                          setEmailError("Invalid email format");
                        }
                      }}
                      style={{ border: "none", outline: "none", flex: 1, minWidth: "160px", fontSize: "13px", padding: "4px", fontFamily: "Work Sans" }}
                    />
                  </div>
                  {emailError && (
                    <span style={{ color: "red", fontSize: "11px", marginTop: "4px", display: "block" }}>
                      {emailError}
                    </span>
                  )}
                </div>

                <div className='contract-date'>
                  <p className="contract-popup_project_text">
                    Supply Period Start Day
                  </p>
                  <div className="contract-date-input">
                    <input
                      type="number"
                      min="1"
                      max="31"
                      name="supply_period_start_day"
                      value={formData.supply_period_start_day}
                      onChange={handleSupplyDayChange}
                      placeholder="Day (1-31)"
                      className="contract-popup-input date-input"
                      style={{ width: "195.33px", fontFamily: 'Work Sans' }}
                    />
                  </div>
                </div>

                <div className='contract-date'>
                  <p className="contract-popup_project_text">
                    Supply Period End Day
                  </p>
                  <div className="contract-date-input">
                    <input
                      type="number"
                      min="1"
                      max="31"
                      name="supply_period_end_day"
                      value={formData.supply_period_end_day}
                      placeholder="Auto"
                      className="contract-popup-input date-input"
                      style={{
                        width: "195.33px",
                        fontFamily: "Work Sans",
                        backgroundColor: "#f3f4f6",
                        cursor: "not-allowed"
                      }}
                      disabled
                    />
                  </div>
                </div>

              </div>
            </div>

            <div className="contract-popup_job_cards">
              <p className="contract-popup_project_text">Job Cards:</p>
              <div className="project_card_list">
                {selectedJobs.map((jobId, index) => {
                  const job = jobOptions.find(j => j.value === jobId);
                  return (
                    <div key={index} className="project_card_item">
                      <span>{job ? job.label : jobId}</span>
                      <button className="project_card_remove" onClick={() => handleRemoveJob(jobId)}>×</button>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>



          <div className="contracts_popup_categories">
            <div className="select-all-toggle" style={{ marginBottom: "10px", display: "flex", alignItems: "center", marginLeft: "12px", gap: '5px' }}>
              <input
                type="checkbox"
                ref={checkboxRef}
                checked={periodJobs.length === allCategoryIds.length}
                onChange={(e) => {
                  if (e.target.checked) {
                    setPeriodJobs(allCategoryIds);
                    console.log("Select All:", allCategoryIds);
                  } else {
                    setPeriodJobs([]);
                    console.log("Deselect All");
                  }
                }}
              />
              <label style={{ fontSize: '13px', fontWeight: '600', fontFamily: 'Work Sans', cursor: 'pointer', margin: '0px' }}>
                Select All
              </label>
            </div>

            {allCategories.map((category, index) => {
              const totals = calculateCategoryTotals(category);
              const jobType = jobOptions.find(job => job.value === category.id);
              console.log("category", category);
              console.log("category.id", category.id);
              console.log("joboptions", jobOptions);
              return (
                <div key={category.id} className="contracts_popup_outercategory">
                  <div className="contracts_popup_category_header" style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: "10px",
                    padding: "10px",
                    fontWeight: "bold",
                    fontSize: "16px"
                  }}>
                    {/* Checkbox and Job Name */}
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", flexShrink: 0 }}>
                      <input
                        type="checkbox"
                        checked={periodJobs.includes(category.id)}
                        onChange={(e) => {
                          const updated = e.target.checked
                            ? [...periodJobs, category.id]
                            : periodJobs.filter(id => id !== category.id);
                          setPeriodJobs(updated);
                          console.log(`${e.target.checked ? "Adding" : "Removing"} category:`, category.id, updated);
                        }}
                      />
                      <span className="category_name" style={{ fontWeight: "bold", fontSize: '12.5px' }}>
                        {jobType ? jobType.label : category.name}
                      </span>
                    </div>

                    {/* Schedule Icon and Summary */}
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", flexShrink: 0 }}>
                      <span
                        className="schedule_icon"
                        title="Set Schedule"
                        onClick={() => {
                          setJobTypeBeingScheduled(category.id);
                          const existing = jobTypeSchedules[category.id];
                          if (existing) {
                            setSelectedPeriod(existing.periodType || "weekly");
                            setWeeklyInterval(Number(existing.weeklyInterval) || 1);
                            setActiveDay(existing.weeklyDay || "Mon");
                            setMonthlyDay(Number(existing.monthlyDay) || 1);
                            setMonthlyInterval(Number(existing.monthlyInterval) || 1);
                            setTriggerStartDate(existing.triggerStartDate || formData.contract_start_date);
                            setTriggerEndDate(existing.triggerEndDate || formData.contract_expiry_date);
                          } else {
                            setSelectedPeriod("weekly");
                            setWeeklyInterval(1);
                            setActiveDay("Mon");
                            setMonthlyDay(1);
                            setMonthlyInterval(1);
                            setTriggerStartDate(formData.contract_start_date);
                            setTriggerEndDate(formData.contract_expiry_date);
                          }
                          setShowPopup(true);
                        }}
                        style={{ cursor: "pointer", fontSize: "18px" }}
                      >
                        <img src={schedule_icon} alt="Schedule Icon" style={{ height: "19px", width: "19px" }} />
                      </span>

                      {jobTypeSchedules[category.id] && (
                        <span className="schedule-summary" style={{ color: "#666", fontStyle: "italic" }}>
                          — {getReadableSchedule(jobTypeSchedules[category.id])}
                        </span>
                      )}
                    </div>

                    {/* Financial Boxes - will wrap to second row when needed */}
                    <div style={{
                      display: "flex",
                      gap: "12px",
                      fontSize: '12px',
                      flexWrap: "wrap",
                      flexGrow: 1,
                      justifyContent: "flex-start",
                      minWidth: "min-content"
                    }}>
                      {/* SALES BOX */}
                      <div style={{
                        backgroundColor: "#ffffff",
                        borderRadius: "10px",
                        padding: "12px 16px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        height: '30px',
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                        flexShrink: 0
                      }}>
                        <span style={{ color: "green", fontWeight: "600" }}>SALES :</span>
                        <span style={{ color: "#000" }}>Net total : ₹ {category.salesNetTotal?.toLocaleString()}</span>
                      </div>

                      <div style={{
                        width: "1px",
                        backgroundColor: "#ccc",
                        alignSelf: "stretch",
                        flexShrink: 0
                      }} />

                      {/* COST BOX */}
                      <div style={{
                        backgroundColor: "#ffffff",
                        borderRadius: "10px",
                        padding: "12px 16px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        height: '30px',
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                        flexShrink: 0
                      }}>
                        <span style={{ color: "#007bff", fontWeight: "600" }}>COST :</span>
                        <span style={{ color: "#000" }}>Net total : ₹ {category.costNetTotal?.toLocaleString()}</span>
                      </div>

                      <div style={{
                        width: "1px",
                        backgroundColor: "#ccc",
                        alignSelf: "stretch",
                        flexShrink: 0
                      }} />

                      {/* PROFIT BOX */}
                      <div style={{
                        backgroundColor: "#ffffff",
                        borderRadius: "10px",
                        padding: "12px 16px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        height: '30px',
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                        flexShrink: 0
                      }}>
                        <span style={{ color: "purple", fontWeight: "600" }}>PROFIT :</span>
                        <span style={{ color: "#000" }}>Amount : ₹{category.profitAmount?.toLocaleString()}</span>
                        <span style={{ color: "purple", fontWeight: "600" }}>PROFIT % :</span>
                        <span style={{ color: "#000" }}>{category.profitPercent}%</span>
                      </div>
                    </div>
                  </div>

                  <div className="contracts_popup_category_subheader">
                    <div className="contracts_popup_element_list" style={{ overflowX: "auto" }}>
                      <div style={{
                        display: "flex",
                        gap: "12px",
                        fontSize: '12px',
                        flexWrap: "wrap",
                        flexGrow: 1,
                        justifyContent: "flex-start",
                        minWidth: "min-content",
                        padding: '10px',
                        cursor: 'pointer',
                        fontWeight: '600'
                      }}>
                        <div onClick={() => handleViewModeChange(category.id, "split")} style={{
                          backgroundColor: getViewModeForCategory(category.id) === "split" ? "#D0E6FF" : "#EDF3F9",
                          borderRadius: "10px",
                          padding: "12px 16px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          height: '30px',
                          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                          flexShrink: 0,
                          color: getViewModeForCategory(category.id) === "split" ? "#007bff" : "",
                          transition: "all 0.3s ease",
                        }}>
                          <img src={getViewModeForCategory(category.id) === "split" ? split_hover : split} alt="Split View" />
                          <span style={{ transition: "color 0.3s ease" }}>Split View</span>
                        </div>
                        <div style={{
                          width: "1px",
                          backgroundColor: "#ccc",
                          alignSelf: "stretch",
                          flexShrink: 0
                        }} />
                        <div onClick={() => handleViewModeChange(category.id, "sales")} style={{
                          backgroundColor: getViewModeForCategory(category.id) === "sales" ? "#D0E6FF" : "#EDF3F9",
                          borderRadius: "10px",
                          padding: "12px 16px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          height: '30px',
                          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                          flexShrink: 0,
                          color: getViewModeForCategory(category.id) === "sales" ? "#007bff" : "",
                          transition: "all 0.3s ease",
                        }}>
                          <img src={getViewModeForCategory(category.id) === "sales" ? cost_hover : cost} alt="Sales View" />
                          <span style={{ transition: "color 0.3s ease" }}>Sales View</span>
                        </div>
                        <div style={{
                          width: "1px",
                          backgroundColor: "#ccc",
                          alignSelf: "stretch",
                          flexShrink: 0
                        }} />
                        <div onClick={() => handleViewModeChange(category.id, "cost")} style={{
                          backgroundColor: getViewModeForCategory(category.id) === "cost" ? "#D0E6FF" : "#EDF3F9",
                          borderRadius: "10px",
                          padding: "12px 16px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          height: '30px',
                          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                          flexShrink: 0,
                          color: getViewModeForCategory(category.id) === "cost" ? "#007bff" : "",
                          transition: "all 0.3s ease",
                        }}>
                          <img src={getViewModeForCategory(category.id) === "cost" ? sales_hover : sales} alt="Sales View" />
                          <span style={{ transition: "color 0.3s ease" }}>Cost View</span>
                        </div>
                      </div>
                      <div className="tables-wrapper">
                        {(getViewModeForCategory(category.id) === "split" || getViewModeForCategory(category.id) === "sales") && (
                          <div className="table-containers sales-table" ref={getTableRef(category.id, "sales")} style={{
                            position: 'relative', overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth', flex: getViewModeForCategory(category.id) === "split" ? "0 0 50%" : "1 1 100%",
                            width: getViewModeForCategory(category.id) === "split" ? "50%" : "100%", transition: 'flex 0.2s ease',
                            display: getViewModeForCategory(category.id) === "split" ? "block" :
                              (getViewModeForCategory(category.id) === "sales" ? "block" : "none")

                          }}>
                            <table className="invoice_table">
                              <thead>
                                <tr>
                                  <th colSpan="8" style={{ backgroundColor: '#D9FFE2', padding: '10px', color: '#008B1F' }}>SALES</th>
                                </tr>
                                <tr>
                                  <th style={{ backgroundColor: '#D9FFE2' }}>CHARGE CODE</th>
                                  <th style={{ backgroundColor: '#D9FFE2' }}>DESCRIPTION</th>
                                  <th style={{ backgroundColor: '#D9FFE2' }}>PO/WO NO</th>
                                  <th style={{ backgroundColor: '#D9FFE2' }}>PO/WO Date</th>
                                  <th style={{ backgroundColor: '#D9FFE2', padding: '5px' }}>REMARKS</th>
                                  <th style={{ backgroundColor: '#D9FFE2' }}>QTY</th>
                                  <th style={{ backgroundColor: '#D9FFE2' }}>RATE</th>
                                  <th style={{ backgroundColor: '#D9FFE2' }}>NET TOTAL</th>

                                </tr>
                              </thead>
                              <tbody>
                                {category.salesRows.map((row, lineindex) => (
                                  <tr key={lineindex}>
                                    <td style={{ position: "relative" }}>
                                      <div className="table-tooltip-container">
                                        <input
                                          type="text"
                                          style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                          // value={inputValues[index]?.[lineindex] || ""}
                                          value={salesInputValues[index]?.[lineindex]?.split("-")[0]?.trim() || ""}
                                          onChange={(e) => {
                                            const val = e.target.value;
                                            handleCostInputChange(e, index, lineindex, "chargecode");
                                            setSalesInputValues((prev) => ({
                                              ...prev,
                                              [index]: {
                                                ...prev[index],
                                                [lineindex]: val,
                                              },
                                            }));
                                            fetchSalesSuggestions(val, lineindex, index);
                                          }}
                                          onFocus={() => {
                                            const list = salesSuggestionsMap[index]?.[lineindex] || [];
                                            if (list.length > 0) {
                                              const list = salesSuggestionsMap[index]?.[lineindex] || [];
                                              if (list.length > 0) {
                                                setShowSalesSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: true }));
                                              }
                                            }
                                          }}
                                          onBlur={() => {
                                            setTimeout(() => {
                                              setShowSalesSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));
                                            }, 200);
                                          }}
                                          className="invoice_narrow_input_chargecode"
                                          placeholder="Search"
                                        />
                                        {showSalesSuggestionsMap[`${index}_${lineindex}`] && salesSuggestionsMap[index]?.[lineindex]?.length > 0 && (
                                          <ul
                                            style={{
                                              position: "absolute",
                                              top: "100%",
                                              left: 0,
                                              right: 0,
                                              backgroundColor: "white",
                                              border: "1px solid #ccc",
                                              zIndex: 999,
                                              maxHeight: "150px",
                                              overflowY: "auto",
                                              margin: 0,
                                              padding: 0,
                                              listStyle: "none",
                                            }}
                                          >
                                            {salesSuggestionsMap[index]?.[lineindex].map((item) => (
                                              <li
                                                key={item.value}
                                                onMouseDown={() => {
                                                  const selected = item.label;
                                                  const chargeId = item.value;

                                                  setSalesInputValues((prev) => ({
                                                    ...prev,
                                                    [index]: {
                                                      ...prev[index],
                                                      [lineindex]: selected,
                                                    },
                                                  }));

                                                  setSelectedSalesChargeIds((prev) => ({
                                                    ...prev,
                                                    [`${index}_${lineindex}`]: chargeId
                                                  }));

                                                  handleSalesInputChange({ target: { value: selected } }, index, lineindex, "chargecode");
                                                  setShowSalesSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));

                                                  // ✨ NEW PART: split and set description separately ✨
                                                  const splitParts = selected.split("-");
                                                  const chargeCodeOnly = splitParts[0] || "";
                                                  const descriptionOnly = splitParts.slice(1).join("-") || "";


                                                  // Update charge code field value (CT002)
                                                  setSalesInputValues((prev) => ({
                                                    ...prev,
                                                    [index]: {
                                                      ...prev[index],
                                                      [lineindex]: chargeCodeOnly,
                                                    },
                                                  }));

                                                  handleSalesInputChange({ target: { value: chargeCodeOnly } }, index, lineindex, "chargecode");

                                                  // Update description field value (TestCharge)
                                                  handleSalesInputChange({ target: { value: descriptionOnly } }, index, lineindex, "description");
                                                }}
                                                style={{
                                                  padding: "8px",
                                                  cursor: "pointer",
                                                  borderBottom: "1px solid #eee",
                                                }}
                                              >
                                                {item.label}
                                              </li>
                                            ))}
                                          </ul>
                                        )}
                                        <span className="add-contract-tooltip">
                                          {salesInputValues[index]?.[lineindex]?.split("-")[0]?.trim() ? salesInputValues[index]?.[lineindex]?.split("-")[0]?.trim() : ""}
                                        </span>
                                      </div>
                                    </td>
                                    <td style={{ position: "relative" }}>
                                      <div className="table-tooltip-container">
                                        <input
                                          type="text"
                                          value={row.description}
                                          onChange={(e) => handleSalesInputChange(e, index, lineindex, "description")}
                                          className="invoice_narrow_input_description"
                                          style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                        />
                                        <span className="add-contract-tooltip">
                                          {row.description ? row.description : ""}
                                        </span>

                                      </div>
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        value={row.po_wo_number || ""}
                                        onInput={(e) => {
                                          e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                        }}
                                        onChange={(e) => {
                                          if (e.target.value.length <= 10) {
                                            handleSalesInputChange(e, index, lineindex, "po_wo_number");
                                          }
                                        }}
                                        className="invoice_narrow_input"
                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                      />
                                    </td>

                                    <td>
                                      <input
                                        type="date"
                                        value={row.po_wo_date || ""}
                                        onChange={(e) => handleSalesInputChange(e, index, lineindex, "po_wo_date")}
                                        className="invoice_narrow_input"
                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                      />
                                    </td>
                                    {/* SALES */}
                                    <td>
                                      <div
                                        className="table-tooltip-container"
                                        style={{ display: "flex", alignItems: "center", gap: "6px" }}
                                      >
                                        <input
                                          type="text"
                                          value={row.salesRemarks || ""}
                                          onChange={(e) =>
                                            handleSalesInputChange(e, index, lineindex, "salesRemarks")
                                          }
                                          className="invoice_narrow_input_remarks"
                                          style={{ margin: "0px", fontFamily: "Work Sans", fontSize: "13px" }}
                                        />
                                        {row.salesRemarks?.trim() && (
                                          <SquarePen
                                            size={16}
                                            onClick={() =>
                                              openRemarkPopup("sales", index, lineindex, row.salesRemarks)
                                            }
                                          />
                                        )}

                                        <span className="add-contract-tooltip">
                                          {row.salesRemarks}
                                        </span>
                                      </div>
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        value={row.SalesunitQuantity}
                                        onChange={(e) => handleSalesInputChange(e, index, lineindex, "SalesunitQuantity")}
                                        className="invoice_narrow_input_quantity"
                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        value={row.salesRate}
                                        onChange={(e) => handleSalesInputChange(e, index, lineindex, "salesRate")}
                                        className="invoice_narrow_input"
                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        value={row.salesNetTotal}
                                        readOnly
                                        className="invoice_narrow_input"
                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                      />
                                    </td>
                                    <td
                                      style={{
                                        position: 'sticky',
                                        right: 0,
                                        background: 'white',
                                        zIndex: 1,
                                        textAlign: 'center',
                                        padding: 0,
                                        boxShadow: '-2px 0 5px rgba(0,0,0,0.1)'
                                      }}
                                    >
                                      <button onClick={() => deleteRow(category.id, lineindex, 'sales')} className="delete-btn">
                                        <img src={delete_icon} alt="Delete" />
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            <div
                              className="add_new_row"
                              onClick={() => addSalesRow(index)}
                              style={{ cursor: "pointer" }}
                            >
                              <span className="add_new_row_popup">
                                <img src={plus_icon} alt="" />
                                Add Sales Row
                              </span>
                            </div>
                          </div>
                        )}

                        {(getViewModeForCategory(category.id) === "split") && <DraggableDivider leftRef={getTableRef(category.id, "sales")}
                          rightRef={getTableRef(category.id, "cost")} />}

                        {(getViewModeForCategory(category.id) === "split" || getViewModeForCategory(category.id) === "cost") && (
                          <div className="table-containers cost-table" ref={getTableRef(category.id, "cost")} style={{
                            position: 'relative', overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth', flex: getViewModeForCategory(category.id) === "split" ? "1 1 0px" : "1 1 100%",
                            width: getViewModeForCategory(category.id) === "split" ? "auto" : "100%", transition: 'flex 0.2s ease',
                            display: getViewModeForCategory(category.id) === "split" ? "block" :
                              (getViewModeForCategory(category.id) === "cost" ? "block" : "none")
                          }}>
                            <table className="invoice_table">
                              <thead>
                                <tr>
                                  <th colSpan="9" style={{ backgroundColor: '#E0EFFF', padding: '10px', color: '#097BED' }}>COST</th>
                                </tr>
                                <tr>
                                  <th style={{ backgroundColor: '#E0EFFF' }}>CHARGE CODE</th>
                                  <th style={{ backgroundColor: '#E0EFFF' }}>DESCRIPTION</th>
                                  <th style={{ backgroundColor: '#E0EFFF' }}>VENDOR</th>
                                  <th style={{ backgroundColor: '#E0EFFF' }}>PO/WO NO</th>
                                  <th style={{ backgroundColor: '#E0EFFF' }}>PO/WO Date</th>
                                  <th style={{ backgroundColor: '#E0EFFF', padding: '3px' }}>REMARKS</th>
                                  <th style={{ backgroundColor: '#E0EFFF' }}>QTY</th>
                                  <th style={{ backgroundColor: '#E0EFFF' }}>RATE</th>
                                  <th style={{ backgroundColor: '#E0EFFF' }}>NET TOTAL</th>
                                </tr>
                              </thead>
                              <tbody>
                                {category.costRows.map((row, lineindex) => (
                                  <tr key={lineindex}>
                                    <td style={{ position: "relative" }}>
                                      <div className="table-tooltip-container">
                                        <input
                                          type="text"
                                          style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                          value={costInputValues[index]?.[lineindex]?.split("-")[0]?.trim() || ""}
                                          onChange={(e) => {
                                            const val = e.target.value;
                                            handleCostInputChange(e, index, lineindex, "chargecode");
                                            setCostInputValues((prev) => ({
                                              ...prev,
                                              [index]: {
                                                ...prev[index],
                                                [lineindex]: val,
                                              },
                                            }));
                                            fetchCostSuggestions(val, lineindex, index);
                                          }}
                                          onFocus={() => {
                                            const list = costSuggestionsMap[index]?.[lineindex] || [];
                                            if (list.length > 0) {
                                              const list = costSuggestionsMap[index]?.[lineindex] || [];
                                              if (list.length > 0) {
                                                setShowCostSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: true }));
                                              }
                                            }
                                          }}
                                          onBlur={() => {
                                            setTimeout(() => {
                                              setShowCostSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));
                                            }, 200);
                                          }}
                                          className="invoice_narrow_input_chargecode"
                                          placeholder="Search"
                                        />
                                        {showCostSuggestionsMap[`${index}_${lineindex}`] && costSuggestionsMap[index]?.[lineindex]?.length > 0 && (
                                          <ul
                                            style={{
                                              position: "absolute",
                                              top: "100%",
                                              left: 0,
                                              right: 0,
                                              backgroundColor: "white",
                                              border: "1px solid #ccc",
                                              zIndex: 999,
                                              maxHeight: "150px",
                                              overflowY: "auto",
                                              margin: 0,
                                              padding: 0,
                                              listStyle: "none",
                                            }}
                                          >
                                            {costSuggestionsMap[index]?.[lineindex].map((item) => (
                                              <li
                                                key={item.value}
                                                onMouseDown={() => {
                                                  const selected = item.label;
                                                  const chargeId = item.value;

                                                  setCostInputValues((prev) => ({
                                                    ...prev,
                                                    [index]: {
                                                      ...prev[index],
                                                      [lineindex]: selected,
                                                    },
                                                  }));

                                                  setSelectedCostChargeIds((prev) => ({
                                                    ...prev,
                                                    [`${index}_${lineindex}`]: chargeId
                                                  }));

                                                  handleCostInputChange({ target: { value: selected } }, index, lineindex, "chargecode");
                                                  setShowCostSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));

                                                  // ✨ NEW PART: split and set description separately ✨
                                                  const splitParts = selected.split("-");
                                                  const chargeCodeOnly = splitParts[0] || "";
                                                  const descriptionOnly = splitParts.slice(1).join("-") || "";


                                                  // Update charge code field value (CT002)
                                                  setCostInputValues((prev) => ({
                                                    ...prev,
                                                    [index]: {
                                                      ...prev[index],
                                                      [lineindex]: chargeCodeOnly,
                                                    },
                                                  }));

                                                  handleCostInputChange({ target: { value: chargeCodeOnly } }, index, lineindex, "chargecode");

                                                  // Update description field value (TestCharge)
                                                  handleCostInputChange({ target: { value: descriptionOnly } }, index, lineindex, "description");
                                                }}
                                                style={{
                                                  padding: "8px",
                                                  cursor: "pointer",
                                                  borderBottom: "1px solid #eee",
                                                }}
                                              >
                                                {item.label}
                                              </li>
                                            ))}
                                          </ul>
                                        )}
                                        <span className="add-contract-tooltip">
                                          {costInputValues[index]?.[lineindex]?.split("-")[0]?.trim()}
                                        </span>
                                      </div>
                                    </td>
                                    <td>
                                      <div className="table-tooltip-container">
                                        <input
                                          type="text"
                                          value={row.description}
                                          onChange={(e) => handleCostInputChange(e, index, lineindex, "description")}
                                          className="invoice_narrow_input_description"
                                          style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                        />
                                        <span className="add-contract-tooltip">
                                          {row.description}
                                        </span>
                                      </div>
                                    </td>

                                    {/* COST */}
                                    <td style={{ position: 'relative' }}>
                                      <div className="table-tooltip-container">
                                        <input
                                          type="text"
                                          className="contracts_small_input"
                                          style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                          value={vendorInputValues[`${index}_${lineindex}`] || ""}
                                          onChange={async (e) => {
                                            const val = e.target.value;
                                            setVendorInputValues(prev => ({
                                              ...prev,
                                              [`${index}_${lineindex}`]: val,
                                            }));

                                            if (val === "") {
                                              setSelectedVendorIds(prev => ({
                                                ...prev,
                                                [`${index}_${lineindex}`]: 0,
                                              }));
                                            }

                                            if (val.length >= 1) { // Changed from 2 to 1 to show suggestions immediately
                                              const suggestions = await fetchVendorSuggestions(val);
                                              setVendorSuggestions(suggestions);
                                              setShowVendorSuggestions(prev => ({
                                                ...prev,
                                                [`${index}_${lineindex}`]: true,
                                              }));
                                            } else {
                                              setShowVendorSuggestions(prev => ({
                                                ...prev,
                                                [`${index}_${lineindex}`]: false,
                                              }));
                                            }
                                          }}
                                          onFocus={async () => {
                                            const val = vendorInputValues[`${index}_${lineindex}`] || "";
                                            if (val.length >= 1) {
                                              const suggestions = await fetchVendorSuggestions(val);
                                              setVendorSuggestions(suggestions);
                                              setShowVendorSuggestions(prev => ({
                                                ...prev,
                                                [`${index}_${lineindex}`]: true,
                                              }));
                                            }
                                          }}
                                          onBlur={() => {
                                            setTimeout(() => {
                                              setShowVendorSuggestions(prev => ({
                                                ...prev,
                                                [`${index}_${lineindex}`]: false,
                                              }));
                                            }, 200);
                                          }}
                                          placeholder="Search vendor"
                                        />
                                        {showVendorSuggestions[`${index}_${lineindex}`] && vendorSuggestions.length > 0 && (
                                          <ul
                                            style={{
                                              position: "absolute",
                                              top: "100%",
                                              left: 0,
                                              right: 0,
                                              backgroundColor: "white",
                                              border: "1px solid #ccc",
                                              zIndex: 999,
                                              maxHeight: "150px",
                                              overflowY: "auto",
                                              margin: 0,
                                              padding: 0,
                                              listStyle: "none",
                                            }}
                                          >
                                            {vendorSuggestions.map((vendor) => (
                                              <li
                                                key={vendor.value}
                                                onMouseDown={() => {
                                                  setVendorInputValues(prev => ({
                                                    ...prev,
                                                    [`${index}_${lineindex}`]: vendor.label,
                                                  }));
                                                  setSelectedVendorIds(prev => ({
                                                    ...prev,
                                                    [`${index}_${lineindex}`]: vendor.value,
                                                  }));
                                                  setShowVendorSuggestions(prev => ({
                                                    ...prev,
                                                    [`${index}_${lineindex}`]: false,
                                                  }));
                                                }}
                                                style={{
                                                  padding: "8px",
                                                  cursor: "pointer",
                                                  borderBottom: "1px solid #eee",
                                                }}
                                              >
                                                {vendor.label}
                                              </li>
                                            ))}
                                          </ul>
                                        )}
                                        <span className="add-contract-tooltip">
                                          {vendorInputValues[`${index}_${lineindex}`]}
                                        </span>
                                      </div>
                                    </td>

                                    <td>
                                      <input
                                        type="text"
                                        value={row.po_wo_number || ""}
                                        onInput={(e) => {
                                          e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                        }}
                                        onChange={(e) => {
                                          if (e.target.value.length <= 10) {
                                            handleCostInputChange(e, index, lineindex, "po_wo_number");
                                          }
                                        }}
                                        className="invoice_narrow_input"
                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                      />
                                    </td>

                                    <td>
                                      <input
                                        type="date"
                                        value={row.po_wo_date || ""}
                                        onChange={(e) => handleCostInputChange(e, index, lineindex, "po_wo_date")}
                                        className="invoice_narrow_input"
                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                      />
                                    </td>
                                    <td>
                                      <div
                                        className="table-tooltip-container"
                                        style={{ display: "flex", alignItems: "center", gap: "6px" }}
                                      >
                                        <input
                                          type="text"
                                          value={row.costRemarks || ""}
                                          onChange={(e) =>
                                            handleCostInputChange(e, index, lineindex, "costRemarks")
                                          }
                                          className="invoice_narrow_input_remarks"
                                          style={{ margin: "0px", fontFamily: "Work Sans", fontSize: "13px" }}
                                        />

                                        {row.costRemarks?.trim() && (
                                          <SquarePen
                                            size={16}
                                            onClick={() =>
                                              openRemarkPopup("cost", index, lineindex, row.costRemarks)
                                            }
                                          />
                                        )}

                                        <span className="add-contract-tooltip">
                                          {row.costRemarks}
                                        </span>
                                      </div>
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        value={row.CostunitQuantity}
                                        onChange={(e) => {
                                          handleCostInputChange(e, index, lineindex, "CostunitQuantity");

                                        }}
                                        className="invoice_narrow_input_quantity"
                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        value={row.costRate}
                                        onChange={(e) => {
                                          handleCostInputChange(e, index, lineindex, "costRate");

                                        }}
                                        className="invoice_narrow_input"
                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        value={row.costNetTotal}
                                        readOnly
                                        className="invoice_narrow_input"
                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                      />
                                    </td>
                                    <td
                                      style={{
                                        position: 'sticky',
                                        right: 0,
                                        background: 'white',
                                        zIndex: 1,
                                        textAlign: 'center',
                                        padding: 0,
                                        boxShadow: '-2px 0 5px rgba(0,0,0,0.1)'
                                      }}
                                    >
                                      <button onClick={() => deleteRow(category.id, lineindex, 'cost')} className="delete-btn">
                                        <img src={delete_icon} alt="Delete" />
                                      </button>
                                    </td>
                                  </tr>

                                ))}
                              </tbody>
                            </table>
                            <div
                              className="add_new_row"
                              onClick={() => addCostRow(index)}
                              style={{ cursor: "pointer" }}
                            >
                              <span className="add_new_row_popup">
                                <img src={plus_icon} alt="" />
                                Add Cost Row
                              </span>
                            </div>
                          </div>
                        )}
                      </div>

                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      )}
      <CommonFooter />
      <CommonRemarkPopup
        show={showRemarkPopup}
        onClose={() => setShowRemarkPopup(false)}
        onSave={handleSaveRemark}
        initialValue={remarkValue}
        title={
          remarkMeta?.type === "cost"
            ? "Cost Remarks"
            : "Sales Remarks"
        }
      />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </>
  );
};

export default ContractsPopup;